/**
 * Global object contains commonly used functionality
 */
 const Global = (() => {
  const DEBUG = true;

  let storedTopValue = 0;

  /* Functions */
  /* - Cart */
  const Cart = () => {
    /**
     * Handles initialization on load
     */
    function loadHandler() {
      return;
    }

    /**
     * @param {Promise} - Object {id (product id, integer), quantity (quantity to add, integer)}
     * @returns {Object} Returns object with results.
     */
    function add({id = undefined, quantity = 0} = {}) {
      return new Promise(function (resolve, reject) {
        if (id === undefined || quantity === 0) {
          if (DEBUG) {
            console.warn("No id or quantity provided.");
          };

          reject({
            "error": "No id or quantity provided.",
          });

          return;
        }

        fetch("/cart/add.js", {
          body: JSON.stringify({
            items: [
              {
                id,
                quantity,
              }
            ]
          }),
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (res.status >= 400) {
            if (DEBUG) {
              console.warn(res);
            }

            reject(res);
          } else {
            if (DEBUG) {
              console.log(res);
            }

            SKCart.addToCartCallback();

            resolve(res);
          }

          return;
        })
        .catch(res => {
          if (DEBUG) {
            console.warn(res);
          }

          reject(res);
          return;
        });
      });
    }

    /**
     * @param {Promise} - Object {id (product id, integer), quantity (quantity to change to, integer)}
     * @returns {Object} Returns object with results.
     */
    function update({id = undefined, quantity = 0} = {}) {
      return new Promise(function (resolve, reject) {
        if (id === undefined || quantity === 0) {
          if (DEBUG) {
            console.warn("No id or quantity provided.");
          }

          reject({
            "error": "No id or quantity provided.",
          });

          return;
        }

        fetch("/cart/update.js", {
          body: JSON.stringify({
            items: [
              {
                id,
                quantity,
              }
            ]
          }),
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (res.status >= 400) {
            if (DEBUG) {
              console.warn(res);
            }

            reject(res);
          } else {
            if (DEBUG) {
              console.log(res);
            }

            SKCart.addToCartCallback();

            resolve(res);
          }

          return;
        })
        .catch(res => {
          if (DEBUG) {
            console.warn(res);
          }

          reject(res);
          return;
        });
      });
    }

    /**
     * @returns {Promise} Object with results.
     */
    function cart() {
      return new Promise(function (resolve, reject) {
        fetch("/cart.js")
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (res.status >= 400) {
            if (DEBUG) {
              console.warn(res);
            }

            reject(res);
          } else {
            if (DEBUG) {
              console.log(res);
            }

            resolve(res);
          }
          return;
        })
        .catch(res => {
          if (DEBUG) {
            console.warn(res);
          }

          reject(res);
          return;
        });
      });
    }

    /**
     * @param {Promise} - Object {id (product id, integer (id) or string (key)), quantity (quantity to set - set to 0 to remove, integer)}
     * @returns {Object} Returns object with results.
     */
    function change({id = undefined, quantity = 1} = {}) {
      return new Promise(function (resolve, reject) {
        if (id === undefined) {
          if (DEBUG) {
            console.warn("No id provided.");
          }

          reject({
            "error": "No id provided.",
          });
          return;
        }

        const targetId = (typeof id === 'string' || id instanceof String) ? id : `${id}`;

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: targetId,
            quantity,
          }),
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (res.status >= 400) {
            if (DEBUG) {
              console.warn(res);
            }

            reject(res);
          } else {
            if (DEBUG) {
              console.log(res);
            }

            SKCart.addToCartCallback();

            resolve(res);
          }
          return;
        })
        .catch(res => {
          if (DEBUG) {
            console.warn(res);
          }

          reject(res);
          return;
        });
      });
    }

    /**
     * @param {Promise} - Object {id (product id, integer (id) or string (key))}
     * @returns {Object} Returns object with results.
     */
    function remove({id = undefined} = {}) {
      return new Promise(function (resolve, reject) {
        if (id === undefined) {
          if (DEBUG) {
            console.warn("No id provided.");
          }

          reject({
            "error": "No id provided.",
          });
          return;
        }

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id,
            quantity: 0,
          }),
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (res.status >= 400) {
            if (DEBUG) {
              console.warn(res);
            }

            reject(res);
          } else {
            if (DEBUG) {
              console.log(res);
            }

            SKCart.addToCartCallback();

            resolve(res);
          }
          return;
        })
        .catch(res => {
          if (DEBUG) {
            console.warn(res);
          }

          reject(res);
          return;
        });
      });
    }

    function cartSubmit() {
      Global.Overlay.Background.startLoading();
    }

    // Init cart submit
    Array.from(document.querySelectorAll(".cart > form")).forEach(form => {
      form.addEventListener("submit", cartSubmit);
    });

    // Hide loading before page redirects
    window.addEventListener("beforeunload", () => {
      function exitLoading() {
        Global.Overlay.Background.endLoading();
        document.removeEventListener("click", exitLoading);
      }

      document.addEventListener("click", exitLoading);
    });

    return Object.freeze({
      add,
      update,
      cart,
      change,
      loadHandler,
      remove,
      cartSubmit,
    });
  };

  /* - Mail */
  const Mail = () => {
    /* Helpers */
    const Validator = (() => {
      function isValidCountry(country = "") {
        if (country === "") {
          return false;
        }

        return true;
      }

      function isValidEmail(email = "") {
        let emailPattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})+$/;

        return emailPattern.test(email);
      }

      return Object.freeze({
        isValidCountry,
        isValidEmail,
      });
    })();

    /* Get properties */
    async function getPropertiesByEmail(email = "") {
      return new Promise((resolve, reject) => {
        if (!Validator.isValidEmail(email)) {
          if (DEBUG) {
            console.warn("Invalid email.");
          }

          reject({
            msg: "No email provided",
            response: JSON.stringify({
              msg: "No email provided",
              response: "false",
              status: "error",
            }),
            status: "error",
          });

          return;
        }

        fetch("https://sukoshi-custom-backend-server.herokuapp.com/retrieve_email_properties", {
          "body": JSON.stringify({
            email,
          }),
          "headers": {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          "method": "PUT",
          "mode": "cors",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (DEBUG) {
            console.log("getPropertiesByEmail - success");
            console.log(res);
          }

          resolve(res);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn("getPropertiesByEmail - fail");
            console.warn(res);
          }

          reject(res);
        });
      });
    }

    /* Subscribe to list */
    async function subscribeEmailToList({email = "", listId = ""}) {
      return new Promise((resolve, reject) => {
        if (!Validator.isValidEmail(email)) {
          if (DEBUG) {
            console.warn("Invalid email.");
          }

          reject({
            msg: "No email provided",
            response: JSON.stringify({
              msg: "No email provided",
              response: "false",
              status: "error",
            }),
            status: "error",
          });

          return;
        }

        fetch("https://sukoshi-custom-backend-server.herokuapp.com/subscribe_email_to_list", {
          "body": JSON.stringify({
            "email": email,
            "listId": listId,
          }),
          "headers": {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          "method": "PUT",
          "mode": "cors",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (DEBUG) {
            console.log("subscribeEmailToList - success");
            console.log(res);
          }

          // Set signed up local storage value
          localStorage.setItem("mailing-signed-up", "true");

          resolve(res);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn("subscribeEmailToList - fail");
            console.warn(res);
          }

          reject(res);
        });
      });
    }

    /* Subscribe to list via two step */
    async function subscribeEmailToListTwoStep({email = "", listId = ""}) {
      return new Promise((resolve, reject) => {
        if (!Validator.isValidEmail(email)) {
          if (DEBUG) {
            console.warn("Invalid email.");
          }

          reject({
            msg: "No email provided",
            response: JSON.stringify({
              msg: "No email provided",
              response: "false",
              status: "error",
            }),
            status: "error",
          });

          return;
        }

        fetch("https://sukoshi-custom-backend-server.herokuapp.com/subscribe_email_to_list_two_step", {
          "body": JSON.stringify({
            "email": email,
            "listId": listId,
          }),
          "headers": {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          "method": "PUT",
          "mode": "cors",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (DEBUG) {
            console.log("subscribeEmailToListTwoStep - success");
            console.log(res);
          }

          // Set signed up local storage value
          localStorage.setItem("mailing-signed-up", "true");

          resolve(res);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn("subscribeEmailToListTwoStep - fail");
            console.warn(res);
          }

          reject(res);
        });
      });
    }

    /* In List? */
    async function isEmailInList({email = "", listId = ""}) {
      return new Promise((resolve, reject) => {
        if (!Validator.isValidEmail(email)) {
          if (DEBUG) {
            console.warn("Invalid email.");
          }

          reject({
            msg: "No email provided",
            response: "false",
            status: "error",
          });

          return;
        }

        fetch("https://sukoshi-custom-backend-server.herokuapp.com/is_email_in_list", {
          "body": JSON.stringify({
            "email": email,
            "listId": listId,
          }),
          "headers": {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          "method": "PUT",
          "mode": "cors",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (DEBUG) {
            console.log("isEmailInList - success");
            console.log(res);
          }

          resolve(res);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn("isEmailInList - fail");
            console.warn(res);
          }

          reject(res);
        });
      });
    }

    /* Update properties */
    async function updatePropertiesByEmail({
          email = "",
          fname = "",
          lname = "",
          country = "",
          news = "FALSE",
          instoreSales = "FALSE",
          onlineSales = "FALSE"
        }) {
      return new Promise((resolve, reject) => {
        if (!Validator.isValidEmail(email)) {
          if (DEBUG) {
            console.warn("Invalid email.");
          }

          reject({
            msg: "No email provided",
            response: JSON.stringify({
              msg: "No email provided",
              response: "false",
              status: "error",
            }),
            status: "error",
          });

          return;
        }

        if (country !== "" && !Validator.isValidCountry(country)) {
          if (DEBUG) {
            console.warn("Invalid country");
          }

          reject({
            msg: "Invalid country provided",
            response: JSON.stringify({
              msg: "Invalid country provided",
              response: "false",
              status: "error",
            }),
            status: "error",
          });

          return;
        }

        // Create properties to be updated that is conditional on input
        let newProperties = {
          "$email": email,
          "Latest News & Announcements": news,
          "In-Store Promotions, Sales & Events": instoreSales,
          "Online Promotions, Sales & Events": onlineSales,
        }

        if (country !== "") {
          newProperties["$country"] = country.toUpperCase();
        }

        if (fname !== "") {
          newProperties["$first_name"] = fname;
        }

        if (lname !== "") {
          newProperties["$last_name"] = lname;
        }

        fetch("https://sukoshi-custom-backend-server.herokuapp.com/update_email_properties", {
          "body": JSON.stringify({
            "email": email,
            "properties": newProperties,
          }),
          "headers": {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          "method": "PUT",
          "mode": "cors",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (DEBUG) {
            console.log("updatePropertiesByEmail - success");
            console.log(res);
          }

          resolve(res);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn("updatePropertiesByEmail - fail");
            console.warn(res);
          }

          reject(res);
        });
      });
    }

    /* Unsubscribe email */
    async function unsubscribeEmailFromList({email = "", listId = ""}) {
      return new Promise((resolve, reject) => {
        if (!Validator.isValidEmail(email)) {
          if (DEBUG) {
            console.warn("Invalid email.");
          }

          reject({
            msg: "No email provided",
            response: JSON.stringify({
              msg: "No email provided",
              response: "false",
              status: "error",
            }),
            status: "error",
          });

          return;
        }

        fetch("https://sukoshi-custom-backend-server.herokuapp.com/unsubscribe_email_from_list", {
          "body": JSON.stringify({
            "email": email,
            "listId": listId,
          }),
          "headers": {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          "method": "PUT",
          "mode": "cors",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (DEBUG) {
            console.log("unsubscribeEmailFromList - success");
            console.log(res);
          }

          resolve(res);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn("unsubscribeEmailFromList - fail");
            console.warn(res);
          }

          reject(res);
        });
      });
    }

    /* Get Fulfilled Orders by Email */
    async function getFulfilledOrdersByEmail({email = ""}) {
      return new Promise((resolve, reject) => {
        if (!Validator.isValidEmail(email)) {
          if (DEBUG) {
            console.warn("Invalid email.");
          }

          reject({
            msg: "No email provided",
            response: JSON.stringify({
              msg: "No email provided",
              response: "false",
              status: "error",
            }),
            status: "error",
          });

          return;
        }

        fetch("https://sukoshi-custom-backend-server.herokuapp.com/fulfilled_orders", {
          "body": JSON.stringify({
            email,
          }),
          "headers": {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          "method": "PUT",
          "mode": "cors",
        })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (DEBUG) {
            console.log("getFulfilledOrders - success");
            console.log(res);
          }

          resolve(res);
        })
        .catch(res => {
          if (DEBUG) {
            console.warn("getFulfilledOrders - fail");
            console.warn(res);
          }

          reject(res);
        });
      });
    }

    return Object.freeze({
      getPropertiesByEmail,
      getFulfilledOrdersByEmail,
      isEmailInList,
      subscribeEmailToList,
      subscribeEmailToListTwoStep,
      updatePropertiesByEmail,
      unsubscribeEmailFromList,
      Validator,
    });
  }

  /* Overlay */
  const Overlay = () => {
    const bodyRoot = document.querySelector("#body-root");
    const overlayRoot = document.querySelector("#overlay-root");
    const overlayMain = document.querySelector("#overlay-main");
    const overlayBg = document.querySelector("#overlay-bg");
    const overlayBgDesktop = document.querySelector("#overlay-bg-desktop");
    const overlayBgMobile = document.querySelector("#overlay-bg-mobile");
    const overlayBg1023 = document.querySelector("#overlay-bg-1023");

    // Loading
    const overlayLoadingBg = document.querySelector("#overlay-loading-bg");
    const overlayLoadingCircle = document.querySelector("#overlay-loading-circle");

    /**
     * Background - Controls background for overlay
     */
    const Background = (() => {
      // All items that are shown via active. Linking name == class
      const activeItems = [
        "cart--side-cart",
        "mobile-nav",
      ];

      let topOffsetBeforeOverlay = 0;
      let isLoading = false;
      let isFrozenWhileNotLoading = false;

      /* Freeze Screen */
      function freezeScreen() {
        // - Stop screen
        // Save current top offset
        topOffsetBeforeOverlay = window.scrollY;

        // Remove smooth scroll
        document.body.style.scrollBehavior = "auto";

        // Freeze screen
        bodyRoot.style.position = "fixed";
        bodyRoot.style.top = `-${topOffsetBeforeOverlay}px`;

        window.scrollTo({
          top: 0,
          left: 0,
          scrollBehavior: "auto",
        });
      }

      function unfreezeScreen() {
        // Unfreeze screen
        bodyRoot.style.position = "";
        bodyRoot.style.top = "";

        // Scroll back to original scroll position
        window.scrollTo({
          top: topOffsetBeforeOverlay,
          left: 0,
          scrollBehavior: "auto",
        });

        // Reset smooth scroll
        document.body.style.scrollBehavior = "";
      }

      /* Overlay visibility */
      function disableOverlay(e) {
        overlayRoot.classList.add("sk-hidden");
        overlayMain.classList.add("sk-hidden");

        overlayBg.classList.add("sk-hidden");
        overlayBgDesktop.classList.add("sk-hidden");
        overlayBgMobile.classList.add("sk-hidden");
        overlayBg1023.classList.add("sk-hidden");
        overlayLoadingBg.classList.add("sk-hidden");
        overlayLoadingCircle.classList.add("sk-hidden");

        unfreezeScreen();
        isFrozenWhileNotLoading = false;
      }

      /**
       * Hides background
       */
      let hideTimeout = undefined;
      let hideDelay = 0;

      function hide({linkedFuncs = [], view = "all"} = {}) {
        if (hideTimeout) {
          clearTimeout(hideTimeout);
        }

        if (hideDelay > 0) {
          hideTimeout = setTimeout(() => {
            hideCallback({linkedFuncs, view});
          }, hideDelay);
        } else {
          hideCallback({linkedFuncs, view});
        }
      }

      function hideCallback({linkedFuncs = [], view = "all"} = {}) {
        // Hide all items
        // hideAllOverlayItems();

        if (view === "1023") {
          // Hide background
          overlayBg1023.classList.remove("active");
          setTimeout(disableOverlay, 500);

          // Remove event listeners from linkedFuncs
          if (linkedFuncs.length > 0) {
            linkedFuncs.forEach(func => {
              overlayBg1023.removeEventListener("click", func);
            });
          }

          // Remove listener
          overlayBg1023.removeEventListener("click", hide);
        } else {
          // Hide background
          overlayBg.classList.remove("active");
          overlayBgDesktop.classList.remove("active");
          overlayBgMobile.classList.remove("active");
          overlayBg1023.classList.remove("active");
          overlayLoadingBg.classList.remove("active");
          overlayLoadingCircle.classList.remove("active");
          setTimeout(disableOverlay, 500);

          // Remove listener
          overlayBg.removeEventListener("click", hide);
          overlayBgDesktop.removeEventListener("click", hide);
          overlayBgMobile.removeEventListener("click", hide);
          overlayBg1023.removeEventListener("click", hide);

          // Remove event listeners from linkedFuncs
          if (linkedFuncs.length > 0) {
            linkedFuncs.forEach(func => {
              overlayBg.removeEventListener("click", func);
              overlayBgDesktop.removeEventListener("click", func);
              overlayBgMobile.removeEventListener("click", func);
              overlayBg1023.removeEventListener("click", func);
            });
          }
        }

        setTimeout(() => {
          try {
            OverlayBtnManager.OverlayBtns.showAllOverlayBtns();
          } catch {
            if (DEBUG) {
              console.warn("No overlay buttons found.");
            }
          }
        }, 100);
      }

      /**
       * Hide all overlay items
       */
      function hideAllOverlayItems() {
        // hide all overlay items by removing active if activeItems or adding sk-hidden if other
        Array.from(overlayRoot.querySelectorAll("#overlay-main > *")).forEach(item => {
          if (!item.classList.contains("overlay-bg") &&
              !item.classList.contains("overlay-loading-bg") &&
              !item.classList.contains("overlay-loading-circle")) {
            if (activeItems.some(className => item.classList.contains(className))) {
              item.classList.remove("active");
            } else {
              // Default to sk hidden if not in active items
              item.classList.add("sk-hidden");
            }
          }
        });
      }

      /**
       * Disable all overlay items
       */
      function disableAllOverlayItems() {
        // hide all overlay items by removing active if activeItems or adding sk-hidden if other
        Array.from(overlayRoot.querySelectorAll("#overlay-main > *")).forEach(item => {
          if (!item.classList.contains("overlay-bg") &&
              !item.classList.contains("overlay-loading-bg") &&
              !item.classList.contains("overlay-loading-circle")) {
            item.classList.add("sk-hidden");
            item.classList.remove("active");
          }
        });
      }

      /**
       * Shows background
       */
      function show({linkedFuncs = [], view = "all", delay = 0} = {}) {
        hideDelay = delay;

        let targetOverlayBg = undefined;

        // Decide overlay background to use based on view
        if (view === "1023") {
          targetOverlayBg = overlayBg1023;
        } else if (view === "mobile") {
          targetOverlayBg = overlayBgMobile;
        } else {
          targetOverlayBg = overlayBg;
        }

        freezeScreen();
        isFrozenWhileNotLoading = true;

        // - Start overlay
        // Unhide root, overlay, and overlay bg
        overlayRoot.classList.remove("sk-hidden");
        overlayMain.classList.remove("sk-hidden");
        targetOverlayBg.classList.remove("sk-hidden");

        // Add click listener
        targetOverlayBg.addEventListener("click", hide);

        // Add event listeners from linkedFuncs
        if (linkedFuncs.length > 0) {
          linkedFuncs.forEach(func => {
            targetOverlayBg.addEventListener("click", func);
          });
        }

        try {
          OverlayBtnManager.GChat.hideChatWindow();

          setTimeout(() => {
            OverlayBtnManager.OverlayBtns.hideAllOverlayBtns();
          }, 10);
        } catch {
          if (DEBUG) {
            console.warn("No overlay buttons found.");
          }
        }

        // Add active to overlay bg after 10ms
        setTimeout(() => {targetOverlayBg.classList.add("active");}, 100);
      }

      // Loading
      function startLoading() {
        if (!isFrozenWhileNotLoading && !isLoading) {
          freezeScreen();
        }

        // Main
        overlayRoot.classList.remove("sk-hidden");
        overlayMain.classList.remove("sk-hidden");

        // Loading
        overlayLoadingBg.classList.remove("sk-hidden");
        overlayLoadingCircle.classList.remove("sk-hidden");

        setTimeout(() => {
          overlayLoadingBg.classList.add("active");
          overlayLoadingCircle.classList.add("active");
        }, 100);

        isLoading = true;
      }

      function endLoading() {
        overlayLoadingBg.classList.remove("active");
        overlayLoadingCircle.classList.remove("active");

        setTimeout(disableLoading, 500);
      }

      function disableLoading() {
        overlayLoadingBg.classList.add("sk-hidden");
        overlayLoadingCircle.classList.add("sk-hidden");

        if (!isFrozenWhileNotLoading) {
          overlayRoot.classList.add("sk-hidden");
          overlayMain.classList.add("sk-hidden");
          unfreezeScreen();
        }

        isLoading = false;
      }

      // Init
      // hide root, overlay, and overlay bg
      overlayRoot.classList.add("sk-hidden");
      overlayMain.classList.add("sk-hidden");

      overlayBg.classList.add("sk-hidden");
      overlayBgDesktop.classList.add("sk-hidden");
      overlayBgMobile.classList.add("sk-hidden");
      overlayBg1023.classList.add("sk-hidden");

      overlayBg.classList.remove("active");
      overlayBgDesktop.classList.remove("active");
      overlayBgMobile.classList.remove("active");
      overlayBg1023.classList.remove("active");

      overlayLoadingBg.classList.add("sk-hidden");
      overlayLoadingCircle.classList.add("sk-hidden");

      overlayLoadingBg.classList.remove("active");
      overlayLoadingCircle.classList.remove("active");

      disableAllOverlayItems();

      return Object.freeze({
        show,
        hide,
        startLoading,
        endLoading,
        freezeScreen,
        unfreezeScreen,
      });
    })();

    return Object.freeze({
      Background,
      root: overlayRoot,
    });
  }

  /* Views */
  /* - Side Cart */
  const SideCart = () => {
    let sideCart = undefined;
    let svh = 0;
    let vh = 0;

    /**
     * =====
     * On Start Functions
     * =====
     */
    function loadHandler() {
      // console.log("Side Cart Loaded");

      // Side Cart
      sideCart = {
        root: document.querySelector(".cart.cart--side-cart.cart--new"),
      }

      // Announcement Bar
      sideCart.announcementBar = {
        root: sideCart.root.querySelector(".cart-announcement"),
        content: sideCart.root.querySelector(".cart-announcement p"),
      }

      // Header
      sideCart.header = {
        root: sideCart.root.querySelector(".cart-header"),
        backBtn: sideCart.root.querySelector(".cart-header .cart-header__back-btn"),
        locationBtn: sideCart.root.querySelector(".cart-header .cart-header__location-btn"),
        title: sideCart.root.querySelector(".cart-header h3"),
      }

      sideCart.header.backBtn.addEventListener("click", hide);
      sideCart.header.locationBtn.addEventListener("click", handleLocationBtnClick);

      // Cart State Overlay
      sideCart.footer = {
        root: sideCart.root.querySelector(".cart-footer"),
      }

      // Responsive events
      window.addEventListener("resize", resizeHandler);

      // Unhide parent
      sideCart.root.parentElement.classList.remove("sk-hidden");

      // Init swiper
      let announcementDelay = parseInt(document.querySelector(".cart.cart--new .cart-announcement").getAttribute("data-delay"));
      let hintDelay = parseInt(document.querySelector(".cart-footer__hint-container.swiper").getAttribute("data-delay"));

      sideCart.announcementSwiper = new Swiper(".cart.cart--new .cart-announcement .swiper", {
        autoplay: {
          delay: announcementDelay,
        },
        rewind: true,
      });

      sideCart.hintSwiper = new Swiper(".cart-footer__hint-container.swiper", {
        autoplay: {
          delay: hintDelay,
        },
        loop: true,
        speed: 1000,
      });

      // Currency Selector
      sideCart.currencyMenu = {
        root: sideCart.root.querySelector(".cart__currency-selector"),
        loading: sideCart.root.querySelector(".cart-currency-selector__block--body .loading-indicator"),
        seeMore: sideCart.root.querySelector(".cart-currency-selector__see-more")
      }

      Array.from(sideCart.currencyMenu.root.querySelectorAll(".cart-currency-selector__select")).forEach(btn => {
        btn.addEventListener("click", setLocation);
      });

      sideCart.currencyMenu.seeMore.addEventListener("click", showRemainingCountries);

      // Overlay
      sideCart.overlay = {
        root: sideCart.root.querySelector(".cart__header-overlay")
      }

      sideCart.overlay.root.addEventListener("click", hideLocationDropdown);

      // Gift
      sideCart.giftBtn = {
        root: sideCart.root.querySelector(".cart-footer__gift-btn")
      }

      sideCart.giftBtn.root.addEventListener("click", giftBtnClickHandler);

      // Gift page
      sideCart.giftPage = {
        root: sideCart.root.querySelector(".cart-body__gift"),
        footerBlock: sideCart.root.querySelector(".cart-footer__block--gift-page"),
        backBtn: sideCart.root.querySelector(".cart-footer__block--gift-page .cart-footer__back-btn"),
        edit: {
          root: sideCart.root.querySelector(".cart-body__gift .cart-gift__edit-message"),
          to: sideCart.root.querySelector(".cart-body__gift .cart-gift__edit-message .cart-gift__to"),
          from: sideCart.root.querySelector(".cart-body__gift .cart-gift__edit-message .cart-gift__from"),
          message: sideCart.root.querySelector(".cart-body__gift .cart-gift__edit-message .cart-gift__message"),
          charLimit: sideCart.root.querySelector(".cart-body__gift .cart-gift__edit-message .cart-gift__char-limit"),
          error: sideCart.root.querySelector(".cart-body__gift .cart-gift__edit-message .cart-gift__error"),
          saveBtn: sideCart.root.querySelector(".cart-body__gift .cart-gift__edit-message .cart-gift__save-btn")
        },
        static: {
          root: sideCart.root.querySelector(".cart-body__gift .cart-gift__static-message"),
          to: sideCart.root.querySelector(".cart-body__gift .cart-gift__static-message .cart-gift__to .content"),
          from: sideCart.root.querySelector(".cart-body__gift .cart-gift__static-message .cart-gift__from .content"),
          message: sideCart.root.querySelector(".cart-body__gift .cart-gift__static-message .cart-gift__message .content"),
          editBtn: sideCart.root.querySelector(".cart-body__gift .cart-gift__static-message .cart-gift__edit-btn")
        },
        noteInput: sideCart.root.querySelector(".cart-footer .cart-footer__block--gift-page input[name='note']"),
        checkoutBtn: sideCart.root.querySelector(".cart-footer .cart-footer__block--gift-page .cart-footer__checkout-btn")
      }

      sideCart.giftPage.backBtn.addEventListener("click", handleGiftBackBtnClick);

      sideCart.giftPage.edit.saveBtn.addEventListener("click", handleSaveGiftMessageClick);
      sideCart.giftPage.static.editBtn.addEventListener("click", handleEditGiftMessageClick);
      sideCart.giftPage.edit.message.addEventListener("input", handleGiftMessageInput);

      sideCart.giftPage.checkoutBtn.addEventListener("click", handleGiftCheckoutClick);

      // Badges
      addBadgeTooltipEvents();
      moveBundleFractionNextToBundleBadge();

      // Side cart line item handlers
      Array.from(sideCart.root.querySelectorAll(".line-item__quantity-plus")).forEach(plusBtn => {
        plusBtn.addEventListener("click", handlePlusClick);
      });

      Array.from(sideCart.root.querySelectorAll(".line-item__quantity-minus")).forEach(minusBtn => {
        minusBtn.addEventListener("click", handleMinusClick);
      });

      Array.from(sideCart.root.querySelectorAll(".line-item__quantity-input")).forEach(input => {
        input.addEventListener("change", handleInputChange);
      });

      // Notification
      sideCart.cartCountDesktop = document.querySelector(".menu-bar .sk-desktop .cart .item-count");
      sideCart.cartCountMobile = document.querySelector(".menu-bar .sk-mobile .cart .item-count");
      // sideCart.cartNotificationDesktop = document.querySelector(".header-nav .header-nav__right-menu.sk-large .cart-btn__notification");
      // sideCart.cartNotificationMobile = document.querySelector(".header-nav .header-nav__right-menu.sk-small-medium .cart-btn__notification");
      // sideCart.cartBlurDesktop = document.querySelector(".header-nav .header-nav__right-menu.sk-large .cart-btn__blur");
      // sideCart.cartBlurMobile = document.querySelector(".header-nav .header-nav__right-menu.sk-small-medium .cart-btn__blur");

      // Product Count
      sideCart.productCount = sideCart.root.querySelector(".cart-footer__product-count");

      // Update vh
      svh = document.getElementById("overlay-svh").getBoundingClientRect().height;
      vh = document.getElementById("overlay-vh").getBoundingClientRect().height;

      // Check for data time badge
      Array.from(document.querySelectorAll(".cart__line-item")).forEach(item => {
        let dataTimeBadges = Array.from(item.querySelectorAll(".line-item__badge-list .badges .badge[data-time]"));

        if (dataTimeBadges.length > 0) {
          dataTimeBadges.forEach(badge => {
            // Get date
            let customBadgeTime = badge.getAttribute("data-time");
            let customBadgeTimeEnd = "";
            let customBadgeTimeActive = false;
            let customBadgeTimeStart = false;

            // Format: mm-dd
            let month = parseInt(customBadgeTime.split("-")[0]);
            let day = parseInt(customBadgeTime.split("-")[1]);
            let year = new Date().getFullYear();

            let nextMonth = "";
            let nextDay = "";
            let nextYear = "";

            // Get month
            switch (month) {
              case 1:
                month = "Jan";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Feb";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 2:
                month = "Feb";

                if (day === 29 && leapYear(year)) {
                  nextDay = 1;
                  nextMonth = "Mar";
                  nextYear = year;
                } else if (day === 28 && !leapYear(year)) {
                  nextDay = 1;
                  nextMonth = "Mar";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 3:
                month = "Mar";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Apr";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 4:
                month = "Apr";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "May";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 5:
                month = "May";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Jun";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 6:
                month = "Jun";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "Jul";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 7:
                month = "Jul";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Aug";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 8:
                month = "Aug";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Sep";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 9:
                month = "Sep";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "Oct";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 10:
                month = "Oct";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Nov";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 11:
                month = "Nov";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "Dec";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 12:
                month = "Dec";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Jan";
                  nextYear = year + 1;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
            }

            // Daylight Savings
            if (isDST(new Date())) {
              customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EDT`);
              customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EDT`);
            } else {
              customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EST`);
              customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EST`);
            }

            // Check if is active time
            let startTimeRemaining = customBadgeTime - new Date().getTime();
            let endTimeRemaining = customBadgeTimeEnd - new Date().getTime();

            // In active time?
            if (startTimeRemaining < 0 && endTimeRemaining > 0) {
              customBadgeTimeActive = true;
            } else {
              customBadgeTimeActive = false;
            }

            // After active time?
            if (startTimeRemaining < 0) {
              customBadgeTimeStart = true;
            }

            // Show if active, otherwise stay hidden
            if (customBadgeTimeActive) {
              badge.classList.remove("sk-hidden");
            } else if (customBadgeTimeStart && badge.innerText === "STAFF PICK") {
              badge.classList.remove("sk-hidden");
            } else {
              // Hide if no other badge
              if (Array.from(badge.parentElement.children).length <= 1) {
                badge.parentElement.classList.add("sk-hidden");
              }
            }
          });
        }
      });

      // Image Loading Listener
      initImageLoadListeners();
    }

    /**
     * Key Listening Functions
     */
    function escapeKeyListener(e) {
      if (e.code === "Escape") {
        e.preventDefault();
        hide();
      }
    }

    /**
     * Resize Functions
     */
    function resizeHandler() {
      if (sideCart.root.classList.contains("active")) {
        hide();
      }
    }

    /**
     * Visibility Functions
     */
    let disableCartTimeout = undefined;
    let hideCartTimeout = undefined;
    let hideCartDelay = 210;

    /* - Show */
    function show(e = undefined) {
      // console.log("Side Cart Show");

      if (e) {
        e.preventDefault();
      }

      // First hide mobile nav menu if active -- this puts back header and announcment banner
      // if (document.querySelector(".mobile-nav-menu").classList.contains("active")) {
      //   MobileNavMenu.View.hide();

      //   setTimeout(() => {
      //     show();
      //   }, 610);

      //   return;
      // }

      // Show overlay background
      Global.Overlay.Background.show({
        linkedFuncs: [hide],
        delay: hideCartDelay,
      });

      // Remove notification
      // sideCart.cartNotificationDesktop.classList.remove("active");
      // sideCart.cartNotificationMobile.classList.remove("active");

      // Escape listener
      document.addEventListener("keydown", escapeKeyListener);

      setTimeout(() => {
        // Reset side cart top offset
        sideCart.root.style.top = "0";

        // unhide item by removing sk-hidden
        sideCart.root.classList.remove("sk-hidden");

        // Set active page
        if (sideCart.root.querySelector(".cart__line-item")) {
          forceActivePage("items");
        } else {
          forceActivePage("empty");
        }
      }, 100);

      // add active after time
      setTimeout(() => {
        sideCart.root.classList.add("active");

        // Focus cart icon
        // headerClose.focus();
      }, 200);

      sideCart.root.style.position = "fixed";
      scrollTo({top: 0, left: 0, scrollBehavior: "auto"});

      setTimeout(() => {
        sideCart.root.style.position = "";
      }, 100);
    }

    /* - Hide */
    function hide(e = undefined) {
      // console.log("Side Cart Hide");

      if (e) {
        e.preventDefault();
      }

      if (hideCartTimeout) {
        clearTimeout(hideCartTimeout);
      }

      // Hide children first before closing
      hideCartFooter();
      hideLocationDropdown();
      hideAllBadgeTooltips();

      hideCartTimeout = setTimeout(() => {
        // Add side cart top offset
        sideCart.root.style.top = `-${window.scrollY}px`;

        // remove active class
        sideCart.root.classList.remove("active");

        if (disableCartTimeout) {
          clearTimeout(disableCartTimeout);
        }

        disableCartTimeout = setTimeout(disableSideCart, 500);

        // Escape listener
        document.removeEventListener("keydown", escapeKeyListener);

        // Focus cart icon
        // headerCartIcon.focus();

        // Hide overlay background
        Global.Overlay.Background.hide({
          linkedFuncs: [hide],
        });
      }, hideCartDelay);
    }

    function disableSideCart() {
      // hide
      sideCart.root.classList.add("sk-hidden");
    }

    /**
     * =====
     * Refresh Functions
     * =====
     */
    /*
        Checks Daylight Savings
    */
    function isDST(d) {
      let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
      let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
      return Math.max(jan, jul) !== d.getTimezoneOffset();
    }

    /*
        Checks leap year
    */
    function leapYear(year) {
      return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }

    /* - Refresh */
    async function refresh({refreshFull = true} = {}) {
      // console.log("Side Cart Refresh");

      // Show loading
      let cartOverlay = document.querySelector(".cart.cart--side-cart.cart--new .cart__header-overlay");
      let cartLoading = document.querySelector(".cart.cart--side-cart.cart--new .cart__loading-circle");

      Array.from(document.querySelectorAll("button[name='checkout']")).forEach(btn => {
        btn.disabled = true;
      });

      cartLoading.classList.remove("sk-hidden");
      cartOverlay.classList.remove("sk-hidden");

      setTimeout(() => {
        cartOverlay.classList.add("active");
      }, 100);

      // Get cart
      let cartPage = await fetch(`${document.body.getAttribute("data-locale")}/cart`)
      .then(function (res) {
        return res.text();
      })
      .then(function (res) {
        let newBody = document.createElement("div");
        newBody.innerHTML = res;

        return {body: newBody};
      })
      .catch(function (res) {
        if (DEBUG) {
          console.warn("error: ", res);
        }

        return {
          "error": res,
        };
      });

      if (cartPage["error"]) {
        // Hide loading
        const cartOverlay = document.querySelector(".cart.cart--side-cart.cart--new .cart__header-overlay");
        const cartLoading = document.querySelector(".cart.cart--side-cart.cart--new .cart__loading-circle");

        cartLoading.classList.add("sk-hidden");
        cartOverlay.classList.remove("active");

        setTimeout(() => {
          cartOverlay.classList.add("sk-hidden");
        }, 210);

        return cartPage["error"];
      }

      // Update item count
      let itemCount = parseInt(cartPage.body.querySelector(".menu-bar .cart .item-count").innerText);
      updateCartCount(itemCount);

      sideCart.productCount.innerText = `${itemCount} Item`;

      if (itemCount > 1) {
        sideCart.productCount.innerText += "s";
      }

      // New cart init
      let newSideCart = cartPage.body.querySelector(".cart.cart--side-cart.cart--new");
      // sideCart.root.innerHTML = newSideCart.innerHTML;

      // loadHandler();

      // let cartBody = newSideCart.querySelector(".cart-body");
      // let cartFooter = newSideCart.querySelector(".cart-footer");

      // empty page?
      if (itemCount <= 0) {
        forceActivePage("empty");
      } else {
        forceActivePage("items");
      }

      // Clear current line items
      let currLineItems = Array.from(document.querySelectorAll(".cart__line-item"));
      currLineItems.forEach(item => item.remove());

      // Add new line items
      let currLineItemContainer = document.querySelector(".cart-body__line-item-list");
      let newLineItems = Array.from(newSideCart.querySelectorAll(".cart__line-item"));

      newLineItems.forEach(item => currLineItemContainer.appendChild(item));

      // Hydrate line items
      currLineItems = Array.from(document.querySelectorAll(".cart__line-item"));
      currLineItems.forEach(item => {
        let minusBtn = item.querySelector(".line-item__quantity-minus");
        let plusBtn = item.querySelector(".line-item__quantity-plus");
        let quantityInput = item.querySelector(".line-item__quantity-input");

        if (minusBtn) minusBtn.addEventListener("click", handleMinusClick);
        if (plusBtn) plusBtn.addEventListener("click", handlePlusClick);
        if (quantityInput) quantityInput.addEventListener("change", handleInputChange);
      });

      // Update badges
      addBadgeTooltipEvents();
      moveBundleFractionNextToBundleBadge();

      // Check for custom badge time
      currLineItems.forEach(item => {
        let dataTimeBadges = Array.from(item.querySelectorAll(".line-item__badge-list .badges .badge[data-time]"));

        if (dataTimeBadges.length > 0) {
          dataTimeBadges.forEach(badge => {
            // Get date
            let customBadgeTime = badge.getAttribute("data-time");
            let customBadgeTimeEnd = "";
            let customBadgeTimeActive = false;
            let customBadgeTimeStart = false;

            // Format: mm-dd
            let month = parseInt(customBadgeTime.split("-")[0]);
            let day = parseInt(customBadgeTime.split("-")[1]);
            let year = new Date().getFullYear();

            let nextMonth = "";
            let nextDay = "";
            let nextYear = "";

            // Get month
            switch (month) {
              case 1:
                month = "Jan";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Feb";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 2:
                month = "Feb";

                if (day === 29 && leapYear(year)) {
                  nextDay = 1;
                  nextMonth = "Mar";
                  nextYear = year;
                } else if (day === 28 && !leapYear(year)) {
                  nextDay = 1;
                  nextMonth = "Mar";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 3:
                month = "Mar";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Apr";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 4:
                month = "Apr";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "May";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 5:
                month = "May";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Jun";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 6:
                month = "Jun";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "Jul";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 7:
                month = "Jul";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Aug";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 8:
                month = "Aug";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Sep";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 9:
                month = "Sep";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "Oct";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 10:
                month = "Oct";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Nov";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 11:
                month = "Nov";

                if (day === 30) {
                  nextDay = 1;
                  nextMonth = "Dec";
                  nextYear = year;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
              case 12:
                month = "Dec";

                if (day === 31) {
                  nextDay = 1;
                  nextMonth = "Jan";
                  nextYear = year + 1;
                } else {
                  nextDay = parseInt(day) + 1;
                  nextMonth = month;
                  nextYear = year;
                }
                break;
            }

            // Daylight Savings
            if (isDST(new Date())) {
              customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EDT`);
              customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EDT`);
            } else {
              customBadgeTime = Date.parse(`${day} ${month} ${year} 10:00:00 EST`);
              customBadgeTimeEnd = Date.parse(`${nextDay} ${nextMonth} ${nextYear} 10:00:00 EST`);
            }

            // Check if is active time
            let startTimeRemaining = customBadgeTime - new Date().getTime();
            let endTimeRemaining = customBadgeTimeEnd - new Date().getTime();

            // In active time?
            if (startTimeRemaining < 0 && endTimeRemaining > 0) {
              customBadgeTimeActive = true;
            } else {
              customBadgeTimeActive = false;
            }

            // After active time?
            if (startTimeRemaining < 0) {
              customBadgeTimeStart = true;
            }

            // Show if active, otherwise stay hidden
            if (customBadgeTimeActive) {
              badge.classList.remove("sk-hidden");
            } else if (customBadgeTimeStart && badge.innerText === "STAFF PICK") {
              badge.classList.remove("sk-hidden");
            } else {
              // Hide if no other badge
              if (Array.from(badge.parentElement.children).length <= 1) {
                badge.parentElement.classList.add("sk-hidden");
              }
            }
          });
        }
      });

      // Update footer total with new total
      let currFooter = document.querySelector(".cart.cart--new.cart--side-cart .cart-footer");
      let newFooter = newSideCart.querySelector(".cart-footer");

      let currFooterPriceContainer = currFooter.querySelector(".cart-footer__price-container");
      let currFooterPriceContainerElem = currFooter.querySelector(".cart-footer__price");
      let currFooterComparePriceContainerElem = currFooter.querySelector(".cart-footer__compare-price");

      let newFooterPrice = newFooter.querySelector(".cart-footer__price").innerText;
      let newFooterComparePrice = newFooter.querySelector(".cart-footer__compare-price").innerText;
      let newFooterCompareExists = newFooter.querySelector(".cart-footer__price-container").classList.contains("cart-footer__price-container--compare");

      currFooterPriceContainerElem.innerText = newFooterPrice;

      if (newFooterCompareExists) {
        currFooterPriceContainer.classList.add("cart-footer__price-container--compare");
        currFooterComparePriceContainerElem.innerText = newFooterComparePrice;
      } else {
        currFooterPriceContainer.classList.remove("cart-footer__price-container--compare");
        currFooterComparePriceContainerElem.innerText = "";
      }

      // Image Load
      initImageLoadListeners();

      // If on full cart page, update full cart
      try {
        if (refreshFull && typeof ViewCart !== 'undefined') {
          ViewCart.refresh({refreshSide: false});
        }
      } catch (e) {
        if (DEBUG) {
          console.warn("Not on full cart page", e);
        }
      }

      // Hide loading
      cartOverlay = document.querySelector(".cart.cart--side-cart.cart--new .cart__header-overlay");
      cartLoading = document.querySelector(".cart.cart--side-cart.cart--new .cart__loading-circle");

      cartLoading.classList.add("sk-hidden");
      cartOverlay.classList.remove("active");

      setTimeout(() => {
        cartOverlay.classList.add("sk-hidden");
      }, 210);

      Array.from(document.querySelectorAll("button[name='checkout']")).forEach(btn => {
        btn.disabled = false;
      });
    }

    /**
     * Location Menu
     */
    /* - Click */
    function handleLocationBtnClick(e = undefined) {
      if (e) e.preventDefault();

      RegionSelect.enable();

      // if (sideCart.currencyMenu.root.classList.contains("active")) {
      //   hideLocationDropdown();
      // } else {
      //   showLocationDropdown();
      // }
    }

    /* - Show */
    function showLocationDropdown() {
      // console.log("Show location");

      enableLocationDropdown();
      sideCart.overlay.root.classList.remove("sk-hidden");

      setTimeout(() => {
        sideCart.overlay.root.classList.add("active");
        sideCart.currencyMenu.root.classList.add("active");
      }, 10);

      // Hide item page
      const itemPage = document.querySelector(".cart-body__page[data-page='items']");
      itemPage.style.display = "none";

      // Reset height
      setTimeout(() => {
        initSideCartHeight();
      }, 510);
    }

    function enableLocationDropdown() {
      sideCart.currencyMenu.root.classList.remove("sk-hidden");
    }

    /* - Hide */
    function hideLocationDropdown() {
      // console.log("Hide location");

      sideCart.currencyMenu.root.classList.remove("active");
      sideCart.overlay.root.classList.remove("active");

      setTimeout(() => {
        disableLocationDropdown();
        sideCart.overlay.root.classList.add("sk-hidden");
      }, 310);

      // Show item page if active
      const itemPage = document.querySelector(".cart-body__page[data-page='items']");

      if (itemPage.classList.contains("active")) {
        itemPage.style.display = "";
      }

      // Reset height
      setTimeout(() => {
        initSideCartHeight();
      }, 300);
    }

    function disableLocationDropdown() {
      sideCart.currencyMenu.root.classList.add("sk-hidden");
    }

    /* - Set location */
    function setLocation(e = undefined) {
      if (!e) {
        return;
      }

      e.preventDefault();
      let target = e.currentTarget;
      let country = target.getAttribute("data-country").slice(0, 2);
      let market = target.getAttribute("data-market");

      let top = 9 + target.offsetTop;
      let left = 20;

      sideCart.currencyMenu.loading.classList.remove("sk-hidden");
      sideCart.currencyMenu.loading.style = `top: ${top}px; left: ${left}px;`;

      target.style = "padding-left: 30px; background-position-x: 25px;";

      sessionStorage.setItem("cart-menu__page", "currency");

      Global.Currency.changeAndRefresh({type: country, market: market});

      Array.from(sideCart.currencyMenu.root.querySelectorAll(".cart-currency-selector__select")).forEach(btn => {
        btn.removeEventListener("click", setLocation);
      });
    }

    /* - See more countries*/
    function showRemainingCountries(e = undefined) {
      if (!e) return;

      e.currentTarget.classList.add("sk-hidden");
      let moreCountries = e.currentTarget.parentElement.querySelector(".cart-currency-selector__more-region-list");

      if (moreCountries) {
        moreCountries.classList.remove("sk-hidden");
      }
    }

    /**
     * Page Manager
     */
    let hasPageTransition = true;
    function setActivePage(pageName = "empty") {
      // console.log("Set active to " + pageName);

      if (!hasPageTransition) {
        Array.from(sideCart.root.querySelectorAll(".cart-body__page")).forEach(page => page.style.transition = "");

        hasPageTransition = true;
      }

      let currActivePage = sideCart.root.querySelector(".cart-body__page.active");
      let newActivePage = sideCart.root.querySelector(`.cart-body__page[data-page='${pageName}']`);

      // Show item page if new active
      if (pageName == "items") {
        newActivePage.style.display = "";
      }

      // Set class
      currActivePage.classList.remove("active");
      currActivePage.classList.add("inactive");

      setTimeout(() => {
        newActivePage.classList.remove("inactive");
        newActivePage.classList.add("active");
      }, 100);

      // Hide item page if not active to remove height issue
      if (currActivePage.getAttribute("data-page") == "items" && pageName != "items") {
        setTimeout(() => {
          currActivePage.style.display = "none";
        }, 10);
      }

      // Set cart state overlay
      if (pageName == "items") {
        let footerBlocks = Array.from(sideCart.root.querySelectorAll(".cart-footer__block"));

        footerBlocks.forEach(block => {
          if (!block.classList.contains("cart-footer__block--gift-page")) {
            block.classList.remove("sk-hidden");
          } else {
            block.classList.add("sk-hidden");
          }
        });

        showCartFooter();
      } else {
        hideCartFooter();
      }

      if (pageName == "gift") {
        sideCart.header.title.innerText = "GIFT A LITTLE MORE 🎁";
        sideCart.header.locationBtn.classList.add("sk-invisible");
      } else {
        sideCart.header.title.innerText = "MY CART";
        sideCart.header.locationBtn.classList.remove("sk-invisible");
      }

      // Choose random empty message
      let messages = Array.from(document.querySelectorAll(".body-empty__text-copy"));
      if (messages.length > 0) {
        messages.forEach(message => message.classList.add("sk-hidden"));

        let index = Math.floor(Math.random() * messages.length);
        messages[index].classList.remove("sk-hidden");
      }

      setTimeout(() => {
        initSideCartHeight();
      }, 150);
    }

    function forceActivePage(pageName = "empty") {
      // console.log("Force active to " + pageName);

      if (hasPageTransition) {
        Array.from(sideCart.root.querySelectorAll(".cart-body__page")).forEach(page => page.style.transition = "none");

        hasPageTransition = false;
      }

      let currActivePage = sideCart.root.querySelector(".cart-body__page.active");
      let newActivePage = sideCart.root.querySelector(`.cart-body__page[data-page='${pageName}']`);

      // Show item page if new active
      if (newActivePage.getAttribute("data-page") == "items") {
        newActivePage.style.display = "";
      }

      // Set class
      currActivePage.classList.remove("active");
      currActivePage.classList.add("inactive");

      newActivePage.classList.remove("inactive");
      newActivePage.classList.add("active");

      // Hide item page if not active to remove height issue
      if (currActivePage.getAttribute("data-page") == "items" && pageName != "items") {
        currActivePage.style.display = "none";
      }

      // Set cart state overlay
      if (pageName == "items") {
        let footerBlocks = Array.from(sideCart.root.querySelectorAll(".cart-footer__block"));

        footerBlocks.forEach(block => {
          if (!block.classList.contains("cart-footer__block--gift-page")) {
            block.classList.remove("sk-hidden");
          } else {
            block.classList.add("sk-hidden");
          }
        });

        showCartFooter();
      } else {
        hideCartFooter();
      }

      if (pageName == "gift") {
        sideCart.header.title.innerText = "GIFT A LITTLE MORE 🎁";
        sideCart.header.locationBtn.classList.add("sk-invisible");
      } else {
        sideCart.header.title.innerText = "MY CART";
        sideCart.header.locationBtn.classList.remove("sk-invisible");
      }

      // Choose random empty message
      let messages = Array.from(document.querySelectorAll(".body-empty__text-copy"));
      if (messages.length > 0) {
        messages.forEach(message => message.classList.add("sk-hidden"));

        let index = Math.floor(Math.random() * messages.length);
        messages[index].classList.remove("sk-hidden");
      }

      setTimeout(() => {
        initSideCartHeight();
      }, 150);
    }

    /**
     * Cart State Overlay
     */
    let cartFooterTimeout = undefined;
    let cartFooterShowDelay = 530;
    let cartFooterHideDelay = 200;

    /* Show / Hide */
    function showCartFooter() {
      enableCartFooter();

      if (cartFooterTimeout) {
        clearTimeout(cartFooterTimeout);
      }

      cartFooterTimeout = setTimeout(() => {
        sideCart.footer.root.classList.add("active");
      }, cartFooterShowDelay);
    }

    function hideCartFooter() {
      sideCart.footer.root.classList.remove("active");
      // disableCartFooter();

      if (cartFooterTimeout) {
        clearTimeout(cartFooterTimeout);
      }

      cartFooterTimeout = setTimeout(() => {
        disableCartFooter();
      }, cartFooterHideDelay);
    }

    /* Enable / Disable */
    function enableCartFooter() {
      sideCart.footer.root.classList.add("enabled");
    }

    function disableCartFooter() {
      sideCart.footer.root.classList.remove("enabled");
    }

    /*
      ===== Badge Tooltip =====
    */
    function addBadgeTooltipEvents() {
      let badges = Array.from(sideCart.root.querySelectorAll(".line-item__badge-list .badge"));

      badges.forEach(badge => {
        badge.addEventListener("click", handleBadgeTooltipClick);
        document.addEventListener("click", handleBadgeTooltipClickOff);
        badge.addEventListener("mouseenter", handleBadgeTooltipEnter);
        badge.addEventListener("mouseleave", handleBadgeTooltipLeave);
      });

      window.addEventListener("resize", handleBadgeTooltipResize);
    }

    // - Badge tooltip handlers
    function handleBadgeTooltipClick(e = undefined) {
      if (!e) {
        return;
      }

      let isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

      if (!isDesktop) {
        showBadgeTooltipViaTarget(e.currentTarget);
      }
    }

    function handleBadgeTooltipClickOff(e = undefined) {
      let isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

      if (!isDesktop && e && !e.target.classList.contains("badge", "badge-tooltip")) {
        hideAllBadgeTooltips();
      }
    }

    function handleBadgeTooltipEnter(e = undefined) {
      if (!e) {
        return;
      }

      let isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

      if (isDesktop) {
        showBadgeTooltipViaTarget(e.currentTarget);
      }
    }

    function handleBadgeTooltipLeave(e = undefined) {
      if (!e) {
        return;
      }

      let isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

      if (isDesktop) {
        hideBadgeTooltipViaTarget(e.currentTarget);
      }
    }

    function handleBadgeTooltipResize() {
      hideAllBadgeTooltips();
    }

    function showBadgeTooltipViaTarget(target = undefined) {
      if (!target) {
        return;
      }

      let badgeTitle = target.innerText;
      let badgeParent = target.parentElement;
      let badgeTooltip = target.parentElement.parentElement.querySelector(`.badge-tooltip[data-type='${badgeTitle}']`);

      let badgeParentTop = badgeParent.getBoundingClientRect().top;
      let targetTop = target.getBoundingClientRect().top;
      let targetHeight = target.clientHeight;

      if (!badgeTooltip) {
        return;
      }

      if (badgeTooltip.classList.contains("enabled")) {
        badgeTooltip.classList.remove("active");

        setTimeout(() => {
          badgeTooltip.classList.remove("enabled");
        }, 210);
      } else {
        badgeTooltip.classList.add("enabled");
        badgeTooltip.style = `top: ${targetTop - badgeParentTop + targetHeight}px;`;

        setTimeout(() => {
          badgeTooltip.classList.add("active");
        }, 100);
      }
    }

    function hideBadgeTooltipViaTarget(target = undefined) {
      if (!target) {
        return;
      }

      let badgeTitle = target.innerText;
      let badgeTooltip = target.parentElement.parentElement.querySelector(`.badge-tooltip[data-type='${badgeTitle}']`);

      if (!badgeTooltip) {
        return;
      }

      badgeTooltip.classList.remove("active");

      setTimeout(() => {
        badgeTooltip.classList.remove("enabled");
      }, 210);
    }

    function hideAllBadgeTooltips() {
      let badges = Array.from(sideCart.root.querySelectorAll(".line-item__badge-list .badge-tooltip.enabled"));

      badges.forEach(badge => {
        badge.classList.remove("active");

        setTimeout(() => {
          badge.classList.remove("enabled");
        }, 210);
      });
    }

    function moveBundleFractionNextToBundleBadge() {
      let bundleBadges = Array.from(sideCart.root.querySelectorAll(".bundle-badge"));

      bundleBadges.forEach(badge => {
        let discountMsgElem = badge.closest(".line-item__right").querySelector(".line-item__discount-message");

        if (discountMsgElem) {
          let discountMsg = discountMsgElem.innerText.split("% OFF (");
          discountMsgElem.innerText = discountMsg[0] + "% OFF";

          let badgeNote = "(" + discountMsg[1];
          let badgeNoteElem = document.createElement("div");
          badgeNoteElem.classList.add("badge-note");
          badgeNoteElem.innerText = badgeNote;

          badge.parentElement.insertBefore(badgeNoteElem, badge.nextElementSibling);
        }
      });
    }

    /*
      ===== Gift Btn =====
    */
    async function giftBtnClickHandler(e = undefined) {
      if (!e) {
        return;
      }

      e.preventDefault();

      // console.log("Show gift page");
      setActivePage("gift");

      let footerBlocks = Array.from(sideCart.root.querySelectorAll(".cart-footer__block"));

      footerBlocks.forEach(block => {
        if (!block.classList.contains("cart-footer__block--gift-page")) {
          block.classList.add("sk-hidden");
        } else {
          block.classList.remove("sk-hidden");
        }
      });

      // Check if stored gift message exists, and populate if found
      if (localStorage.getItem("giftMessageContent") && localStorage.getItem("giftMessageContent") !== "" &&
          localStorage.getItem("giftMessageTo") && localStorage.getItem("giftMessageTo") !== "" &&
          localStorage.getItem("giftMessageFrom") && localStorage.getItem("giftMessageFrom") !== "") {
        // get stored values
        let toVal = localStorage.getItem("giftMessageTo");
        let fromVal = localStorage.getItem("giftMessageFrom");
        let messageVal = localStorage.getItem("giftMessageContent");

        // set static
        sideCart.giftPage.static.to.innerText = toVal;
        sideCart.giftPage.static.from.innerText = fromVal;
        sideCart.giftPage.static.message.innerText = messageVal;

        // set edit
        sideCart.giftPage.edit.to.value = toVal;
        sideCart.giftPage.edit.from.value = fromVal;
        sideCart.giftPage.edit.message.value = messageVal;

        // apply gift message
        sideCart.giftPage.noteInput.value = `__GIFT_MESSAGE__ / To: ${toVal} / From: ${fromVal} / Message: ${messageVal}`;

        let charLimit = sideCart.giftPage.edit.charLimit.getAttribute("data-max");
        sideCart.giftPage.edit.charLimit.innerText = `${sideCart.giftPage.edit.message.value.length}/${charLimit}`;

        // Show static
        sideCart.giftPage.edit.root.classList.add("sk-hidden");
        sideCart.giftPage.static.root.classList.remove("sk-hidden");

        // Message for gift card
        if (window.localStorage.getItem("giftMessageTo") !== null &&
            window.localStorage.getItem("giftMessageTo").length !== 0 &&
            window.localStorage.getItem("giftMessageFrom") !== null &&
            window.localStorage.getItem("giftMessageFrom").length !== 0) {
          // console.log("update");
          let result = await GiftCardMessagePropertyUpdater.update();
          // console.log("update");
        }
      } else {
        let charLimit = sideCart.giftPage.edit.charLimit.getAttribute("data-max");
        sideCart.giftPage.edit.charLimit.innerText = `${sideCart.giftPage.edit.message.value.length}/${charLimit}`;

        // Show edit
        sideCart.giftPage.static.root.classList.add("sk-hidden");
        sideCart.giftPage.edit.root.classList.remove("sk-hidden");
      }

      showCartFooter();
    }

    /*
      ===== Gift Page =====
    */
    async function handleGiftBackBtnClick(e = undefined) {
      if (!e) {
        return;
      }

      e.preventDefault();

      // console.log("Back from gift page");
      hideCartFooter();

      setActivePage("items");

      let footerBlocks = Array.from(sideCart.root.querySelectorAll(".cart-footer__block"));

      footerBlocks.forEach(block => {
        if (!block.classList.contains("cart-footer__block--gift-page")) {
          block.classList.remove("sk-hidden");
        } else {
          block.classList.add("sk-hidden");
        }
      });

      // Reset gift
      // Clear gift message
      sideCart.giftPage.noteInput.value = "";

      // Clear gift message static
      sideCart.giftPage.static.to.innerText = "";
      sideCart.giftPage.static.from.innerText = "";
      sideCart.giftPage.static.message.innerText = "";

      // Show edit
      sideCart.giftPage.static.root.classList.add("sk-hidden");
      sideCart.giftPage.edit.root.classList.remove("sk-hidden");

      // Message for gift card
      // console.log("clear");
      let result = await GiftCardMessagePropertyUpdater.clear();
      // console.log("clear");

      showCartFooter();
    }

    async function handleSaveGiftMessageClick(e = undefined) {
      if (!e) {
        return;
      }

      e.preventDefault();

      let toVal = sideCart.giftPage.edit.to.value;
      let fromVal = sideCart.giftPage.edit.from.value;
      let messageVal = sideCart.giftPage.edit.message.value;

      // Make sure to and from have values
      if (toVal.length <= 0 &&
          fromVal.length <= 0
      ) {
        sideCart.giftPage.edit.error.innerText = "Fill out to and from fields";
        sideCart.giftPage.edit.error.classList.remove("sk-hidden");

        // Clear
        let result = await GiftCardMessagePropertyUpdater.clear();

        console.warn("Missing to and from");

        return;
      } else {
        sideCart.giftPage.edit.error.innerText = "";
        sideCart.giftPage.edit.error.classList.add("sk-hidden");
      }

      // Make sure message is not over limit
      let charLimit = sideCart.giftPage.edit.charLimit.getAttribute("data-max");

      if (sideCart.giftPage.edit.message.value.length > parseInt(charLimit)) {
        sideCart.giftPage.edit.error.innerText = "Message is too long";
        sideCart.giftPage.edit.error.classList.remove("sk-hidden");

        // Clear
        let result = await GiftCardMessagePropertyUpdater.clear();

        console.warn("Message over limit");

        return;
      } else {
        sideCart.giftPage.edit.error.innerText = "";
        sideCart.giftPage.edit.error.classList.add("sk-hidden");
      }

      // If message is empty, use placeholder
      if (sideCart.giftPage.edit.message.value.length === 0) {
        messageVal = sideCart.giftPage.edit.message.getAttribute("placeholder");
        messageVal = messageVal.replace("Ex. ", "");

        console.warn("Message empty, use placeholder");
      }

      // Apply gift message
      sideCart.giftPage.noteInput.value = `__GIFT_MESSAGE__ / To: ${toVal} / From: ${fromVal} / Message: ${messageVal}`;

      // Store gift message into static
      sideCart.giftPage.static.to.innerText = toVal;
      sideCart.giftPage.static.from.innerText = fromVal;
      sideCart.giftPage.static.message.innerText = messageVal;

      // Store gift message
      window.localStorage.setItem("giftMessageContent", messageVal);
      window.localStorage.setItem("giftMessageTo", toVal);
      window.localStorage.setItem("giftMessageFrom", fromVal);

      // Show static
      sideCart.giftPage.edit.root.classList.add("sk-hidden");
      sideCart.giftPage.static.root.classList.remove("sk-hidden");

      // Message for gift card
      // console.log("update");
      let result = await GiftCardMessagePropertyUpdater.update();
      // console.log("update");
    }

    async function handleEditGiftMessageClick(e = undefined) {
      if (!e) {
        return;
      }

      e.preventDefault();

      // Clear gift message
      sideCart.giftPage.noteInput.value = "";

      // Clear static text
      sideCart.giftPage.static.to.innerText = "";
      sideCart.giftPage.static.from.innerText = "";
      sideCart.giftPage.static.message.innerText = "";

      // Clear stored gift message
      window.localStorage.setItem("giftMessageContent", "");
      window.localStorage.setItem("giftMessageTo", "");
      window.localStorage.setItem("giftMessageFrom", "");

      // Show edit
      sideCart.giftPage.static.root.classList.add("sk-hidden");
      sideCart.giftPage.edit.root.classList.remove("sk-hidden");

      // Message for gift card
      let result = await GiftCardMessagePropertyUpdater.clear();
    }

    function handleGiftMessageInput(e = undefined) {
      if (!e) {
        return;
      }

      let charLimit = sideCart.giftPage.edit.charLimit.getAttribute("data-max");

      if (sideCart.giftPage.edit.message.value.length > parseInt(charLimit)) {
        sideCart.giftPage.edit.charLimit.style = "color: #da291c;";
      } else {
        sideCart.giftPage.edit.charLimit.style = "";
      }

      sideCart.giftPage.edit.charLimit.innerText = `${sideCart.giftPage.edit.message.value.length}/${charLimit}`;
    }

    async function handleGiftCheckoutClick(e = undefined) {
      if (!sideCart.giftPage.edit.root.classList.contains("sk-hidden")) {
        e.preventDefault();

        sideCart.giftPage.edit.error.classList.remove("sk-hidden");
        sideCart.giftPage.edit.error.innerText = "Save message before checking out";

        return;
      } else {
        sideCart.giftPage.edit.error.classList.add("sk-hidden");
        sideCart.giftPage.edit.error.innerText = "";
      }
    }

    /* Side Cart Refresh Helpers */
    function handlePlusClick(e = undefined) {
      if (!e) {
        return;
      }

      e.preventDefault();

      // console.log("Plus click");

      const quantityElem = e.currentTarget.parentElement.querySelector(".line-item__quantity-input");
      const quantity = parseInt(quantityElem.value);
      let newQuantity = quantity + 1;

      if (newQuantity >= 100) {
        newQuantity = 100;
      }

      // Update quantity
      quantityElem.setAttribute("data-old-qty", quantity);
      quantityElem.value = newQuantity;

      // Trigger event
      quantityElem.dispatchEvent(new Event("change"));
    }

    function handleMinusClick(e = undefined) {
      if (!e) {
        return;
      }

      e.preventDefault();

      // console.log("Minus click");

      const quantityElem = e.currentTarget.parentElement.querySelector(".line-item__quantity-input");
      const quantity = parseInt(quantityElem.value);
      let newQuantity = quantity - 1;

      if (newQuantity <= 0) {
        newQuantity = 0;
      }

      // Update quantity
      quantityElem.setAttribute("data-old-qty", quantity);
      quantityElem.value = newQuantity;

      // Trigger event
      quantityElem.dispatchEvent(new Event("change"));
    }

    async function handleInputChange(e = undefined) {
      if (!e) {
        return;
      }

      const cartLineItem = e.currentTarget.closest(".cart__line-item");

      // console.log("Input change");

      const quantityElem = e.currentTarget;
      let itemKey = cartLineItem.getAttribute("data-key");

      // Grey out number
      quantityElem.style = "color: #c7c7cc !important";

      // Bogo
      const isBogo = cartLineItem.getAttribute("data-is-bogo") === "true" ? true : false;

      if (isBogo) {
        itemKey = parseInt(itemKey.split(":")[0]).toString();
      }

      // Limit of One Check
      const errorMsg = cartLineItem.querySelector(".line-item__error");
      const limitOfOne = cartLineItem.dataset.limit;
      const limitOfOneVariant = cartLineItem.dataset.limitV;
      const productId = parseInt(cartLineItem.dataset.pid);
      const variantId = parseInt(cartLineItem.dataset.vid);

      // Limit of One Data Check
      if (limitOfOne === "true") {
        // Get cart data
        const cartData = await Global.Cart.cart();

        if (limitOfOneVariant === "true") {
          // Limit of One Variant Check (per variant)
          // Check current quantity in cart
          const matchingVariant = cartData.items.find(item => item.variant_id === variantId);

          // If quantity > 1, return error
          if (matchingVariant && matchingVariant.quantity > 1 && quantityElem.value > 0) {
            // Show error
            // - Change quantity to old value
            quantityElem.value = 1;

            // - Black number
            quantityElem.style = "";

            // - Show error
            errorMsg.classList.remove("sk-hidden");
            errorMsg.innerText = "Item limited to 1 per customer!";

            return;
          }
        } else {
          // Limit of One Product Check (per product)
          // Check current quantity
          const matchingItem = cartData.items.find(item => item.product_id === productId);

          // Exists and exceeds quantity limit?
          if (matchingItem && matchingItem.quantity > 0 && quantityElem.value > 0) {
            // Show error
            // - Change quantity to old value
            quantityElem.value = 1;

            // - Black number
            quantityElem.style = "";

            // - Show error
            errorMsg.classList.remove("sk-hidden");
            errorMsg.innerText = "Item limited to 1 per customer!";

            return;
          }
        }
      }

      // Reset error
      errorMsg.classList.add("sk-hidden");
      errorMsg.innerText = "";

      // Change quantity in cart
      Global.Cart.change({id: itemKey, quantity: parseInt(quantityElem.value)})
      .then(res => {
        // On success
        if (DEBUG) {
          console.log(res);
        }

        const savedY = scrollY;

        // Refresh cart
        refresh()
        .then(res => {
          scrollTo(0, savedY);

          if (GiftMessageObj) {
            GiftMessageObj.init();
          }
        });
      })
      .catch(res => {
        // On error
        if (DEBUG) {
          console.warn(res);
        }

        // - Change quantity to old value
        quantityElem.value = parseInt(quantityElem.getAttribute("data-old-qty"));

        // - Black number
        quantityElem.style = "";
      });
    }

    /**
     * Updates cart count
     */
    function updateCartCount(count = 0) {
      if (count <= 0) {
        // sideCart.cartNotificationDesktop.classList.remove("active");
        // sideCart.cartNotificationMobile.classList.remove("active");
        // sideCart.cartBlurDesktop.classList.remove("active");
        // sideCart.cartBlurMobile.classList.remove("active");
      } else {
        // sideCart.cartNotificationDesktop.classList.add("active");
        // sideCart.cartNotificationMobile.classList.add("active");
        // sideCart.cartBlurDesktop.classList.add("active");
        // sideCart.cartBlurMobile.classList.add("active");
      }

      // Clear notification after seconds
      setTimeout(() => {
        // sideCart.cartNotificationDesktop.classList.remove("active");
        // sideCart.cartNotificationMobile.classList.remove("active");
        // sideCart.cartBlurDesktop.classList.remove("active");
        // sideCart.cartBlurMobile.classList.remove("active");

        if (count <= 0) {
          sideCart.cartCountDesktop.classList.add("sk-hidden");
          sideCart.cartCountMobile.classList.add("sk-hidden");
        } else {
          sideCart.cartCountDesktop.classList.remove("sk-hidden");
          sideCart.cartCountMobile.classList.remove("sk-hidden");
        }

        sideCart.cartCountDesktop.innerText = count;
        sideCart.cartCountMobile.innerText = count;
      }, 0);
    }

    let sideCartImages = [];

    /*
      =====
      Image Load Listeners
      =====
    */
    function initImageLoadListeners() {
      sideCartImages = Array.from(sideCart.root.querySelectorAll(".cart__line-item .line-item__left img"));
      sideCartImages.forEach(img => {
        // If image isn't loaded, add load listener
        if (!img.complete) {
          img.addEventListener("load", initSideCartHeight);
        }
      });
    }

    function initSideCartHeight(e = undefined) {
      // console.log("cart height recalc");

      let activePage = sideCart.root.querySelector(".cart-body__page.active");
      if (!activePage) return;

      let pageName = activePage.getAttribute("data-page");

      // Update vh
      svh = document.getElementById("overlay-svh").getBoundingClientRect().height;
      vh = document.getElementById("overlay-vh").getBoundingClientRect().height;

      if (svh < vh) {
        if (pageName == "empty") {
          // console.log("height increase");
          activePage.style.minHeight = "calc(100vh - 230px)";
        } else if (pageName == "items") {
          // console.log("height increase");
          activePage.style.minHeight = "calc(100vh - 230px + 100px)";
        }

        if (pageName == "items") {
          activePage.style.paddingBottom = "250px";
        }
      }

      // Set height
      let calcHeight = activePage.clientHeight + sideCart.announcementBar.root.clientHeight + sideCart.header.root.clientHeight;
      sideCart.root.style.height = `${calcHeight}px`;
    }

    // init
    loadHandler();

    return Object.freeze({
      hide,
      loadHandler,
      refresh,
      show,
      setActivePage,
      forceActivePage,
      showLocationDropdown,
      initSideCartHeight,
    });
  };

  const Currency = () => {
    const currencySelector = document.querySelector("#currency-selector");
    const currencyForm = currencySelector.querySelector("form");
    const currencyInput = currencySelector.querySelector("[name='country_code']");

    // Change currency
    function change({type = undefined, target = undefined} = {}) {
      return new Promise(function (resolve, reject) {
        if (!type) {
          if (DEBUG) {
            console.warn("No type provided");
          }

          reject(false);

          return;
        }

        let loadingIndicator = undefined;

        // show loading indicator
        if (target) {
          loadingIndicator = target.parentElement.querySelector(".loading-indicator");
          loadingIndicator.classList.remove("sk-hidden");
        }

        currencyInput.value = type;

        fetch(currencyForm.action, {
          body: new FormData(currencyForm),
          method: currencyForm.method,
        })
        .then(async function (res) {
          if (DEBUG) {
            console.log(res);
          }

          resolve(true);
        })
        .catch(function (res) {
          if (DEBUG) {
            console.warn(res);
          }

          reject(false);
        });
      });
    }

    // Change and refresh page after successful change
    async function changeAndRefresh({type = undefined, target = undefined, market = undefined} = {}) {
      let res = await change({type, target});

      // console.log("currency: " + type + " / " + market);

      if (res) {
        // console.log("Change currency: ", res);
        if (DEBUG) {
          console.log("Change currency: ", res);
        }

        // Need to add new subdirectories as more regions are supported
        let subdirectory = "";

        // If market not found, use type
        if (market === undefined) {
          market = type;
        }

        switch(market) {
          case "us":
            subdirectory = "/en-us"; break;
          case "eu":
            subdirectory = "/en-eu"; break;
          case "at":
            subdirectory = "/en-eu"; break;
          case "gb":
            subdirectory = "/en-gb"; break;
          case "br":
            subdirectory = "/en-br"; break;
          case "af":
            subdirectory = "/en-af"; break;
          case "as":
            subdirectory = "/en-as"; break;
          case "oc":
            subdirectory = "/en-oc"; break;
          case "na":
            subdirectory = "/en-na"; break;
          case "sa":
            subdirectory = "/en-sa"; break;
          default:
            subdirectory = "";
        }

        if (GiftCardEvent) {
          let result = await GiftCardEvent.refreshCurrencyGiftCards(type);
        }

        let pathNameToUse = location.pathname;

        // Need to add new subdirectories as more regions are supported
        const existingSubDirectories = ["/en-us", "/en-eu", "/en-br", "/en-gb", "/en-af", "/en-as", "/en-oc", "/en-na", "/en-sa"];
        // location.pathname may already contain a subdirectory, so need to remove it
        for (const existingSubDirectory of existingSubDirectories) {
          if (location.pathname.startsWith(existingSubDirectory)) {
            pathNameToUse = location.pathname.replace(existingSubDirectory, "");
          }
        }

        location.replace(location.origin + subdirectory + pathNameToUse);
      }
    }

    // Currency change handler
    function changeHandler(e) {
      const currTarget = e.currentTarget;
      const selectedType = currTarget.options[currTarget.selectedIndex].value;
      const flags = Array.from(currTarget.parentElement.querySelectorAll(".flags div"));

      // Change visible flag to selected type
      flags.forEach(flag => {
        if (flag.classList.contains(selectedType.toLowerCase())) {
          flag.classList.remove("sk-hidden");
        } else {
          flag.classList.add("sk-hidden");
        }
      });

      // Change currency to selected type
      changeAndRefresh({type: selectedType.toLowerCase(), target: currTarget});
    }

    // Init
    const currencySwappers = Array.from(document.querySelectorAll(".currency-selector .currency-selector__select"));

    currencySwappers.forEach(item => {
      item.addEventListener("change", changeHandler);
    })

    return Object.freeze({
      change,
      changeAndRefresh,
      changeHandler,
    });
  };

  /**
   * - Handles overlay that only covers the body
   * */
  const BodyOverlay = () => {
    const bodyRoot = document.querySelector("#body-root");
    const bodyOverlay = document.querySelector("#body-overlay__container");
    const headerOverlay = document.querySelector("#body-overlay-for-header");

    /**
     * Hide Body Overlay
     * - Hides body overlay container
     */
    const hideBodyOverlay = () => {
      bodyOverlay.classList.remove("active");
    }

    /**
     * Show Body Overlay:
     * - Shows body overlay container
     */
    const showBodyOverlay = () => {
      bodyOverlay.classList.add("active");
    }

    /**
     * Hide All Overlays:
     * - Hides all body overlays, including the container
     */
    const hideAllOverlays = () => {
      hideBodyOverlay();
      hideHeaderOverlay();
    }

    /**
     * Hide Header Overlay:
     * - Hides header overlay
     */
    const hideHeaderOverlay = () => {
      headerOverlay.classList.remove("active");
    }

    /**
     * Show Header Overlay:
     * - Shows header overlay
     */
    const showHeaderOverlay = () => {
      showBodyOverlay();
      headerOverlay.classList.add("active");
    }

    return Object.freeze({
      hideAllOverlays,
      hideHeaderOverlay,
      showHeaderOverlay,
    });
  }

  function init() {
    // Overlay
    Global.Overlay = Global.Overlay();
    Global.BodyOverlay = Global.BodyOverlay();

    // Core
    Global.Cart = Global.Cart();
    Global.Currency = Global.Currency();
    Global.Mail = Global.Mail();

    // Side Menus
    Global.SideCart = Global.SideCart();

    // Static
    Object.freeze(Global);
  }

  return {
    BodyOverlay,
    Cart,
    Currency,
    Mail,
    Overlay,
    SideCart,
    init,
  };
})();

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", Global.init);
} else {
  Global.init();
}

/**
 * Desktop Dropdown Nav
 */
let DropdownNav = function () {
  const desktopNavItems = Array.from(document.querySelectorAll(".desktop-nav-item"));
  const dropdownItems = Array.from(document.querySelectorAll(".desktop-nav-dropdown"));

  let dropdownShowTimeout = undefined;
  let dropdownHideTimeout = undefined;

  desktopNavItems.forEach(item => {
    if (item.querySelector(".desktop-nav-dropdown")) {
      item.addEventListener("mouseenter", e => {
        const dropdown = dropdownItems.find(item => item.parentElement === e.currentTarget);

        if (!dropdown) {
          console.warn("Could not find hovered dropdown");
          return;
        }

        // Reset any timeouts
        if (dropdownHideTimeout) {
          clearTimeout(dropdownHideTimeout);
        }

        if (dropdownShowTimeout) {
          clearTimeout(dropdownShowTimeout);
        }

        // Hide all dropdown items
        dropdownItems.forEach(item => {
          item.style.display = "none";
          item.classList.remove("active");
        });

        // Show current dropdown item
        dropdown.style.display = "block";

        dropdownShowTimeout = setTimeout(() => {
          dropdown.classList.add("active");

          // Set the height of each list inside dropdown to height of dropdown
          dropdownShowTimeout = setTimeout(() => {
            Array.from(dropdown.querySelectorAll(".nav-content .nav-row")).forEach(list => {
              list.style.height = `${dropdown.clientHeight - 40}px`; // 40 comes from 20 padding on top and bottom
            });
          }, 50);
        }, 50);
      });

      item.addEventListener("mouseleave", e => {
        const dropdown = dropdownItems.find(item => item.parentElement === e.currentTarget);

        if (!dropdown) {
          console.warn("Could not find hovered dropdown");
          return;
        }

        // Reset any timeouts
        if (dropdownHideTimeout) {
          clearTimeout(dropdownHideTimeout);
        }

        if (dropdownShowTimeout) {
          clearTimeout(dropdownShowTimeout);
        }

        dropdownHideTimeout = setTimeout(() => {
          dropdown.classList.remove("active");

          dropdownHideTimeout = setTimeout(() => {
            dropdown.style.display = "none";

            // reset height for all list
            Array.from(dropdown.querySelectorAll(".nav-content .nav-row")).forEach(list => {
              list.style.height = "";
            });
          }, 50);
        }, 200);
      });
    }
  });

  if (dropdownItems.length > 0) {
    window.addEventListener("scroll", () => {
      dropdownItems.forEach(item => {
        // Reset any timeouts
        if (dropdownHideTimeout) {
          clearTimeout(dropdownHideTimeout);
        }

        if (dropdownShowTimeout) {
          clearTimeout(dropdownShowTimeout);
        }

        // Hide all dropdowns
        dropdownItems.forEach(item => {
          item.style.display = "none";
          item.classList.remove("active");
        });
      })
    });
  }

  return {};
}

// if (document.readyState === "loading") {
//   document.addEventListener("DOMContentLoaded", () => {
//     DropdownNav = DropdownNav();
//   });
// } else {
//   DropdownNav = DropdownNav();
// }

let RegionSelect = () => {
  /* Global Variables */
  let initInterval = undefined;

  // Elements
  let regionSelectElements = {
    root: undefined,
    loading: undefined,
    seeMore: undefined,
  };
  let sideCartRegionBtn = undefined;
  let rebuyCartRegionBtn = undefined;
  let announcementRegionBtn = undefined;
  let hideRegionBtn = undefined;

  // Flags
  let foundRegionElementRoot = false;
  let foundRebuyCartRegionBtn = false;
  let foundSideCartRegionBtn = false;

  /* Init */
  function init() {
    // Search for cart region button before initializing region select
    initInterval = setInterval(() => {
      regionSelectElements.root = document.querySelector(".region-select__currency-selector");
      rebuyCartRegionBtn = document.querySelector(".cart-region-button-container");
      sideCartRegionBtn = document.querySelector(".cart-header__location-btn");

      // console.log("searching");

      // Region select found?
      if (regionSelectElements.root && !foundRegionElementRoot) {
        // console.log("found region select");
        foundRegionElementRoot = true;

        // Elements
        announcementRegionBtn = document.querySelector(".announcement-bar__location-btn.sk-large");
        hideRegionBtn = document.querySelector(".region-select-header__back-btn");

        // Currency Selector
        regionSelectElements.loading = document.querySelector(".region-select-currency-selector__block--body .loading-indicator");
        regionSelectElements.seeMore = document.querySelector(".region-select-currency-selector__see-more");

        // Set region events
        Array.from(regionSelectElements.root.querySelectorAll(".region-select-currency-selector__select")).forEach(btn => {
          btn.addEventListener("click", setRegion);
        });

        // See more event
        regionSelectElements.seeMore.addEventListener("click", showRemainingCountries);

        // Enable events
        // REDESIGN
        // announcementRegionBtn.addEventListener("click", enable);

        // Disable events
        hideRegionBtn.addEventListener("click", disable);
      }

      // Side cart found?
      if (sideCartRegionBtn && !foundSideCartRegionBtn) {
        // console.log("found side cart");
        foundSideCartRegionBtn = true;

        // Enable events
        sideCartRegionBtn.addEventListener("click", enable);
      }

      // Rebuy found?
      if (rebuyCartRegionBtn && !foundRebuyCartRegionBtn) {
        // console.log("found rebuy");
        foundRebuyCartRegionBtn = true;

        // Enable events
        rebuyCartRegionBtn.addEventListener("click", enable);
      }

      // Stop searching if all found
      if (foundSideCartRegionBtn && foundRebuyCartRegionBtn && foundRegionElementRoot) {
        clearInterval(initInterval);
        // console.log("found all");
      }
    }, 500);
  }

  /* Show/Hide */
  function show() {
    // Show
    Global.Overlay.Background.show();
    document.querySelector(".overlay-main .region-select__root").classList.remove("sk-hidden");
    document.querySelector(".overlay-main .region-select__currency-selector").classList.remove("sk-hidden");

    setTimeout(() => {
      // Opacity show
      document.querySelector(".overlay-main .region-select__root").classList.add("active");
    }, 310);
  }

  function hide() {
    // Opacity hide
    document.querySelector(".overlay-main .region-select__root").classList.remove("active");

    setTimeout(() => {
      // Hide completely
      document.querySelector(".overlay-main .region-select__currency-selector").classList.add("sk-hidden");
      document.querySelector(".overlay-main .region-select__currency-selector").parentElement.classList.add("sk-hidden");

      if (foundRebuyCartRegionBtn) {
        Global.Overlay.Background.hide();
      } else {
        if (!document.querySelector(".cart.cart--side-cart").classList.contains("active")) {
          Global.Overlay.Background.hide();
        }
      }
    }, 310);
  }

  function forceShow() {
    Global.Overlay.Background.show();
    document.querySelector(".overlay-main .region-select__root").classList.remove("sk-hidden");
    document.querySelector(".overlay-main .region-select__currency-selector").classList.remove("sk-hidden");
    document.querySelector(".overlay-main .region-select__root").classList.add("active");
  }

  function forceHide() {
    document.querySelector(".overlay-main .region-select__root").classList.remove("active");
    document.querySelector(".overlay-main .region-select__currency-selector").classList.add("sk-hidden");
    document.querySelector(".overlay-main .region-select__currency-selector").parentElement.classList.add("sk-hidden");
    Global.Overlay.Background.hide();
  }

  /* Enable/Disable */
  function enable() {
    // Check rebuy cart
    if (document.querySelector(".rebuy-cart") && document.querySelector(".rebuy-cart").classList.contains("is-visible")) {
      Rebuy.SmartCart.hide();

      // Delay show by 1 second since rebuy cart hides everything when hidden
      setTimeout(() => {
        show();
      }, 1000);
    } else {
      show();
    }
  }

  function disable() {
    hide();
  }

  /* Set region */
  function setRegion(e = undefined) {
    if (!e) {
      return;
    }

    e.preventDefault();
    let target = e.currentTarget;
    let country = target.getAttribute("data-country").slice(0, 2);
    let market = target.getAttribute("data-market");

    let top = 9 + target.offsetTop;
    let left = 20;

    regionSelectElements.loading.classList.remove("sk-hidden");
    regionSelectElements.loading.style = `top: ${top}px; left: ${left}px;`;

    target.style = "padding-left: 30px; background-position-x: 25px;";

    sessionStorage.setItem("cart-menu__page", "currency");

    Global.Currency.changeAndRefresh({type: country, market: market});

    Array.from(regionSelectElements.root.querySelectorAll(".region-select-currency-selector__select")).forEach(btn => {
      btn.removeEventListener("click", setRegion);
    });
  }

  /* See more countries */
  function showRemainingCountries(e = undefined) {
    if (!e) return;

    e.currentTarget.classList.add("sk-hidden");
    let moreCountries = e.currentTarget.parentElement.querySelector(".region-select-currency-selector__more-region-list");

    if (moreCountries) {
      moreCountries.classList.remove("sk-hidden");
    }
  }

  init();

  return Object.freeze({
    enable,
    disable,
    forceShow,
    forceHide,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    RegionSelect = RegionSelect();
  });
} else {
  RegionSelect = RegionSelect();
}

/**
 * Footer Email
 */
let FooterEmail = function () {
  const EmailForm = document.querySelector(".global-footer .footer-newsletter form");

  if (!EmailForm) {
    return;
  }

  // Email inputs
  const EmailInput = EmailForm.querySelector("input[type='text']");
  const ListId = EmailForm.querySelector("input[type='hidden']");

  // Elements
  const notice = document.querySelector(".global-footer .footer-newsletter .newsletter-log");

  EmailForm.addEventListener("submit", e => {
    e.preventDefault();

    // Reset error
    notice.innerText = "";
    notice.classList.remove("success");
    notice.classList.remove("error");
    notice.classList.add("sk-hidden");

    if (!Global.Mail.Validator.isValidEmail(EmailInput.value)) {
      notice.innerText = "Please input a proper email.";
      notice.classList.add("error");
      notice.classList.remove("sk-hidden");

      return;
    }

    Global.Mail.subscribeEmailToList({email: EmailInput.value, listId: ListId.value})
    .then(res => {
      notice.innerText = "Thank you! We added you to our list.";
      notice.classList.add("success");
      notice.classList.remove("sk-hidden");
    })
    .catch(res => {
      notice.innerText = "An error occured. Please try again later.";
      notice.classList.add("error");
      notice.classList.remove("sk-hidden");
    });
  });

  return {};
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    FooterEmail = FooterEmail();
  });
} else {
  FooterEmail = FooterEmail();
}

/* ----- Gifting ----- */
// SK Cart:
// - Handles functionality related to the cart
const SKCart = (function SKCart() {
  // -- Private --
  // Get Line Items:
  // - If found, returns an Array containing the cart's line items as objects
  // - If not found, returns an empty array.
  function getLineItems() {
    return new Promise(function (resolve, reject) {
      fetch("/cart.js").then(function (res) {
        return res.json();
      }).then(function (res) {
        return resolve(res.items);
      }).catch(function (res) {
        return resolve([]);
      });
    });
  }

  // -- Public --
  // Add to Cart Callback:
  // - A function that should be called anytime a product is added to cart
  // - If no errors, returns true
  // - If errors, returns false
  async function addToCartCallback() {
    // if (GiftCardEvent) {
    //   GiftCardEvent.refresh();
    // }

    if (CartCheckpoints) {
      CartCheckpoints.check();
    }

    let result = await GiftCardMessagePropertyUpdater.update();

    return true;
  }

  // Get Note:
  // - Gets the note from the cart
  // - If found, returns the note
  // - If not found, returns an empty string
  function getNote() {
    const noteElem = document.querySelector(".cart--side-cart input[name='note']");
    let note = "";

    if (noteElem && noteElem.value.trim() !== "__GIFT_MESSAGE__ / To: / From: / Message:") {
      note = noteElem.value;
    }

    return note;
  }

  // Find Gift Card:
  // - Searches for a gift card in the cart
  // - If found, returns the id of the found gift card
  // - If not found, returns undefined
  async function findGiftCard() {
    const lineItems = await getLineItems();
    let id = undefined;

    const found = lineItems.find(function (lineItem) {
      return lineItem.product_type.includes("Gift Card");
    });

    if (found) {
      id = found.key;
    }

    return id;
  }

  return Object.freeze({
    addToCartCallback,
    getNote,
    findGiftCard,
  });
})();



// Gift Card Message Property Updater:
// - Handles functionality related to updating gift card properties with a gift message
const GiftCardMessagePropertyUpdater = (function GiftCardMessagePropertyUpdater() {
  // -- Private --

  // Update Gift Card Property:
  // - Sends request to update the property of a provided gift card id within the cart with a provided message
  // - Returns result of request
  function updateGiftCardProperty(id = 0, message = "") {
    // console.log(message);

    return new Promise(function(resolve, reject) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id.toString(),
          properties: {
            _message: message,
          },
        }),
      }).then(function (result) {
        resolve(result);
        return;
      }).catch(function (result) {
        reject(result);
        return;
      });
    });
  }

  // -- Public --
  // Update:
  // - Updates the property of a gift card to the gift message
  // - Returns true if gift card to update is found
  async function update() {
    const id = await SKCart.findGiftCard();
    const message = SKCart.getNote();

    // console.log(id, message);

    if (id) {
      let result = await updateGiftCardProperty(id, message);
      return true;
    }

    return false;
  }

  // Clear:
  // - Clears the property of a gift card
  // - Returns true if gift card to update is found
  async function clear() {
    const id = await SKCart.findGiftCard();

    if (id) {
      let result = await updateGiftCardProperty(id, "");
      return true;
    }

    return false;
  }

  return Object.freeze({
    update,
    clear,
  });
})();

// Oct 27 2021
/*
    GiftCardEvent.refreshGiftCardEvent(); // Should be called every add/remove to cart
    Gift Card Event - Adds a gift card to cart if cart total matches a threshold
*/
let GiftCardEvent = undefined;
const enableGiftCardEvent = false; /* #SK-GCEEF (Gift Card Event Enable Flag) */

if (enableGiftCardEvent) {
  GiftCardEvent = (function GiftCardEvent() {
    let currency = document.body.getAttribute("data-cart-currency").toLowerCase(); // current currency
    let cartTotalThresholds = [];
    let giftCards = [];

    const debug = false; // set to true to see debug log
    const enableMultiRegionGiftCards = false; // set to true to have multi regional gift cards

    // Cart Total Thresholds (#SK-CTT (Cart Total Thresholds))
    /*
        {
          min // minimum value for cart total threshold (inclusive - total >= min)
          max // maximum value for cart total threshold (exclusive - total < max)
          val // gift card value when threshold is matched
        }

        note: to apply no max value, use "inf"
        example:
        {
          min: 100,
          max: "inf",
          val: 5
        }
    */
    const cadCartTotalThresholds = [
      {
        min: 120,
        max: 200,
        val: 10
      },
      {
        min: 200,
        max: 300,
        val: 35
      },
      {
        min: 300,
        max: "inf",
        val: 60
      }
    ];
    const usdCartTotalThresholds = [
      {
        min: 120,
        max: 200,
        val: 10
      },
      {
        min: 200,
        max: 300,
        val: 35
      },
      {
        min: 300,
        max: "inf",
        val: 60
      }
    ];

    // Gift Cards (#SK-GC (Gift Cards))
    /*
        {
          vid // variant id of the gift card matching val ($10 gift card id for val of 10)
          val // gift card value
        }

        example:
        {
          vid: 41178993721506
          val: 10
        }
    */
    const cadGiftCards = [
      {
        vid: 41178993721506,
        val: 10,
      },
      {
        vid: 41178993754274,
        val: 35,
      },
      {
        vid: 41178993787042,
        val: 60,
      }
    ];
    const usdGiftCards = [
      {
        vid: 41179000406178,
        val: 10,
      },
      {
        vid: 41179000438946,
        val: 35,
      },
      {
        vid: 41179000471714,
        val: 60,
      }
    ];

    if (enableMultiRegionGiftCards) {
      // Select threshold and gift cards by current region
      if (currency === "usd") {
        cartTotalThresholds = usdCartTotalThresholds;
        giftCards = usdGiftCards;
      } else {
        cartTotalThresholds = cadCartTotalThresholds;
        giftCards = cadGiftCards;
      }
    } else {
      // Set to cad threshold and gift cards default
      cartTotalThresholds = cadCartTotalThresholds;
      giftCards = cadGiftCards;
    }

    /**
     * Get cart dollar total (no cents) (returns in cad unless multi region is enabled)
     */
    async function getCartDollarTotal() {
      return new Promise (async function (resolve, reject) {
        currency = document.body.getAttribute("data-cart-currency").toLowerCase();
        let result = undefined;

        if (!enableMultiRegionGiftCards) {
          // Change to CAD if in usd
          if (currency === "usd") {
            result = await Global.Currency.change("ca");

            if (!result) {
              resolve(0);
              return;
            }
          }
        }

        // Grab cart data
        fetch("/cart.js")
        .then(res => res.json())
        .then(async function (res) {
          let totalPrice = 0;

          // Get total price
          res.items.forEach(function (item) {
            if (giftCards.find(function (giftCard) {return giftCard.vid === item.variant_id})) {
              totalPrice += item.final_line_price + item.line_level_total_discount;
            } else {
              totalPrice += item.final_line_price;
            }
          });

          if (!enableMultiRegionGiftCards) {
            // Change back to usd if was in usd previously
            if (currency === "usd") {
              result = await Global.Currency.change("us");
            }
          }

          resolve(Math.floor(totalPrice / 100));
        })
        .catch(async function (err) {
          console.warn(err);

          if (!enableMultiRegionGiftCards) {
            // Change back to usd if was in usd previously
            if (currency === "usd") {
              result = await Global.Currency.change("us");
            }
          }

          resolve(0);
        });
      });
    }

    /**
     * Adds a product by variant id to cart
     */
    function addToCart(vid = undefined) {
      return new Promise(function (resolve, reject) {
        if (!vid) {
          resolve(false);
        }

        fetch("/cart/add.js", {
          method: "POST",
          body: JSON.stringify({
            id: vid.toString(),
            quantity: 1
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }).then(function (res) {
          resolve(res.json());

          SKCart.addToCartCallback();
        }).catch(function (res) {
          resolve(res.json());
        });
      });
    }

    /**
     * Returns true if variant id provided is in cart
     * Returns false if variant id provided is not in cart
     */
    function cartContainsProduct(vid = undefined) {
      return new Promise(function (resolve, reject) {
        if (!vid) {
          resolve(false);
        }

        fetch("/cart.js").then(function (res) {
          return res.json();
        }).then(function (res) {
          resolve(res.items.some(function (product) {
            return product.id === vid;
          }));
        }).catch(function (res) {
          resolve(false);
        });
      });
    }

    /**
     * Get quantity of variant id provided from cart
     */
    function getQuantityInCart(vid = undefined) {
      return new Promise(function (resolve, reject) {
        if (!vid) {
          resolve(0);
        }

        fetch("/cart.js").then(function (res) {
          return res.json();
        }).then(function (res) {
          let quantity = 0;

          res.items.forEach(function (product) {
            if (product.variant_id === vid) {
              quantity += product.quantity;
            }
          });

          resolve(quantity);
        }).catch(function (res) {
          resolve(0);
        });
      });
    }

    /**
     * Removes variant id provided from cart by quantity provided
     */
    function removeFromCart(vid = undefined, quantity = 0) {
      return new Promise(function (resolve, reject) {
        if (!vid) {
          resolve(false);
        }

        fetch("/cart/change.js", {
          method: "POST",
          body: JSON.stringify({
            id: vid.toString(),
            quantity: quantity
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }).then(function (res) {
          resolve(res.json());
        }).catch(function (res) {
          resolve(res.json());
        });
      });
    }

    /**
     * Removes any gift card from cart that was active in cart
     */
    async function removeGiftCardEvent() {
      const giftCardEventValue = window.sessionStorage.getItem('giftCardEventValue');

      if (giftCardEventValue !== null && giftCardEventValue !== '') {
        let result = await removeAllGiftCardsFromCart();

        // refresh side cart
        Global.SideCart.refresh();

        // Remove old gift card event
        window.sessionStorage.setItem('giftCardEventValue', '');
      }
    }

    /**
     * Removes all gift cards related to the gift card event from the cart
     */
    async function removeAllGiftCardsFromCart(currency = undefined) {
      if (enableMultiRegionGiftCards) {
        let currencyType = currency;

        if (currencyType === undefined) {
          currencyType = document.body.getAttribute("data-cart-currency");
        }

        currencyType = currencyType.toLowerCase();

        if (currencyType === "usd") {
          for (const giftCard of cadGiftCards) {
            let result = await removeFromCart(giftCard.vid);
          }
        } else {
          for (const giftCard of usdGiftCards) {
            let result = await removeFromCart(giftCard.vid);
          }
        }
      }
      else {
        for (const giftCard of giftCards) {
          let result = await removeFromCart(giftCard.vid);
        }
      }
    }

    /**
     * On success, returns true;
     * On failure, returns false;
     *
     * Checks if cart total matches a discount threshold and adds/removes gift cards from cart accordingly
     */
    async function refresh() {
      // showCartLoading();

      const cartDollarTotal = await getCartDollarTotal();

      // Get threshold matching cart dollar total
      let thresholdToUse = undefined;

      const thresholdBeforeDiscountApplied = cartTotalThresholds.find(function (threshold) {
        if (threshold.max === "inf") {
          return cartDollarTotal >= threshold.min;
        }

        return cartDollarTotal >= threshold.min && cartDollarTotal < threshold.max;
      });

      if (debug) {
        console.log("before applied: total: ", cartDollarTotal, ", threshold found: ", thresholdBeforeDiscountApplied);
      }

      if (!thresholdBeforeDiscountApplied) {
        console.warn("Gift Card Event - No matching threshold found");

        let result = await removeGiftCardEvent();
        // hideCartLoading();

        return false;
      }

      // Get gift card matching threshold before discount applied
      let giftCardToUse = giftCards.find(function (giftCard) {
        return giftCard.val === thresholdBeforeDiscountApplied.val
      });

      if (!giftCardToUse) {
        console.warn("Gift Card Event - No matching gift card found");

        let result = await removeGiftCardEvent();
        // hideCartLoading();

        return false;
      }

      let cartContainsGiftCard = await cartContainsProduct(giftCardToUse.vid);
      const giftCardEventValue = window.sessionStorage.getItem('giftCardEventValue');

      if (debug) {
        console.log("previous gift card: ", giftCardEventValue);
        console.log("gift card to use: ", giftCardToUse);
        console.log("gift card to use in cart: ", cartContainsGiftCard);
      }

      // If gift card already in the cart
      // Get threshold matching cart dollar total after discount is applied
      if (cartContainsGiftCard) {
        let giftCardToSubtract = 0;

        if (giftCardEventValue !== null && giftCardEventValue !== '' && giftCardToUse.val.toString() !== giftCardEventValue) {
          giftCardToSubtract = parseInt(giftCardEventValue);
        }

        if (debug) {
          console.log("to be subtracted from total: ", giftCardToSubtract);
        }

        thresholdToUse = cartTotalThresholds.find(function (threshold) {
          if (threshold.max === "inf") {
            return cartDollarTotal - thresholdBeforeDiscountApplied.val - giftCardToSubtract >= threshold.min;
          }

          return cartDollarTotal - thresholdBeforeDiscountApplied.val - giftCardToSubtract >= threshold.min && cartDollarTotal - thresholdBeforeDiscountApplied.val - giftCardToSubtract < threshold.max;
        });

        if (debug) {
          if (thresholdToUse) {
            console.log("after applied:  total: ", cartDollarTotal - thresholdBeforeDiscountApplied.val - giftCardToSubtract, "threshold to use: ", thresholdToUse);
          } else {
            console.log("no threshold found: total: ", cartDollarTotal, "threshold to use: ", thresholdToUse);
          }
        }

        if (!thresholdToUse) {
          console.warn("Gift Card Event - No matching threshold found");

          let result = await removeGiftCardEvent();
          // hideCartLoading();

          return false;
        }

        // Get gift card matching threshold after discount applied
        giftCardToUse = giftCards.find(function (giftCard) {
          return giftCard.val === thresholdToUse.val
        });

        if (!giftCardToUse) {
          console.warn("Gift Card Event - No matching gift card found");

          let result = await removeGiftCardEvent();
          // hideCartLoading();

          return false;
        }
      } else {
        let giftCardToSubtract = 0;

        if (giftCardEventValue !== null && giftCardEventValue !== '' && giftCardToUse.val.toString() !== giftCardEventValue) {
          giftCardToSubtract = parseInt(giftCardEventValue);
        }

        if (debug) {
          console.log("to be subtracted from total: ", giftCardToSubtract);
        }

        thresholdToUse = cartTotalThresholds.find(function (threshold) {
          if (threshold.max === "inf") {
            return cartDollarTotal - giftCardToSubtract >= threshold.min;
          }

          return cartDollarTotal - giftCardToSubtract >= threshold.min && cartDollarTotal - giftCardToSubtract < threshold.max;
        });

        if (debug) {
          if (thresholdToUse) {
            console.log("after applied:  total: ", cartDollarTotal - thresholdBeforeDiscountApplied.val - giftCardToSubtract, "threshold to use: ", thresholdToUse);
          } else {
            console.log("no threshold found: total: ", cartDollarTotal, "threshold to use: ", thresholdToUse);
          }
        }

        if (!thresholdToUse) {
          console.warn("Gift Card Event - No matching threshold found");

          let result = await removeGiftCardEvent();
          // hideCartLoading();

          return false;
        }

        // Get gift card matching threshold after discount applied
        giftCardToUse = giftCards.find(function (giftCard) {
          return giftCard.val === thresholdToUse.val
        });

        if (!giftCardToUse) {
          console.warn("Gift Card Event - No matching gift card found");

          let result = await removeGiftCardEvent();
          // hideCartLoading();

          return false;
        }
      }

      // Skip if matching gift card already in cart
      cartContainsGiftCard = await cartContainsProduct(giftCardToUse.vid);

      if (cartContainsGiftCard) {
        if (debug) {
          console.log("Matching gift card is already in cart");
        }

        window.sessionStorage.setItem('giftCardEventValue', giftCardToUse.val.toString());
        // hideCartLoading();
        return true;
      }

      // Remove all gift cards from cart if not already in cart
      let result = await removeAllGiftCardsFromCart();

      // refresh side cart
      Global.SideCart.refresh();

      if (debug) {
        console.log("removed all gift cards from cart and refreshed");
      }

      // Add matching gift card to cart
      addToCart(giftCardToUse.vid).then(function (val) {
        window.sessionStorage.setItem('giftCardEventValue', giftCardToUse.val.toString());

        // refresh side cart
        Global.SideCart.refresh();

      }).catch(function (val) {
        console.warn(val);
        // showCartError();
        // hideCartLoading();
      });

      if (debug) {
        console.log(`Added ${document.body.getAttribute("data-currency-symbol")}${giftCardToUse.val} to cart!`);
      }

      return true;
    }

    /**
     * Remove all gift cards from cart that aren't the region currently in
     */
    async function refreshCurrencyGiftCards(currency = undefined, refreshAfter = false) {
      if (enableMultiRegionGiftCards) {
        let result = await removeAllGiftCardsFromCart(currency);

        // refresh side cart
        Global.SideCart.refresh();
      }

      if (refreshAfter) {
        let result = await refresh();
      }

      return true;
    }

    return Object.freeze({refresh, refreshCurrencyGiftCards});
  })();

  GiftCardEvent.refreshCurrencyGiftCards(undefined, true);
}

/*
    Gift Message @ Cart
*/
let giftMessageEnabled = "false";

let GiftMessageObj = (() => {
  function init() {
    if (giftMessageEnabled === "true") {
      const cartGiftingSections = Array.from(document.querySelectorAll(".cart-gifting"));

      cartGiftingSections.forEach(giftSection => {
        // Gifting status triggers
        const checkbox = giftSection.querySelector(".cart-gifting__is-gift > [type='checkbox']");
        const editMessageBtn = giftSection.querySelector(".cart-gifting-view > button");
        const saveMessageBtn = giftSection.querySelector(".cart-gifting-body > button");

        // Gifting components
        const giftingBody = giftSection.querySelector(".cart-gifting-body");
        const giftingView = giftSection.querySelector(".cart-gifting-view");
        const noteInput = giftSection.querySelector("input[type='hidden'][name='note']");

        // Gifting inputs
        const bodyTo = giftingBody.querySelector(".gift-body-to");
        const bodyFrom = giftingBody.querySelector(".gift-body-from");
        const bodyMessage = giftingBody.querySelector(".gift-body-message");
        const bodyCharacters = giftingBody.querySelector("span");

        // Gifting outputs
        const viewTo = giftingView.querySelector(".gift-view-to");
        const viewMessage = giftingView.querySelector(".gift-view-message");
        const viewFrom = giftingView.querySelector(".gift-view-from");
        const viewCharacters = giftingView.querySelector("span");

        // Checkout button
        const checkoutBtn = giftSection.parentElement.parentElement.querySelector(".cart-checkout");

        // Errors
        const giftingError = giftSection.querySelector(".cart-gifting-error");
        const cartError = giftSection.parentElement.parentElement.querySelector(".cart-error");

        // Params
        const characterLimit = 150;
        const giftMessageIdentifier = "__GIFT_MESSAGE__";

        // Error messages
        const fromToErrorMsg = "<span style='font-family: \"BrandonGrotesque-Bold\"'>Oops!</span> Please fill out at least the To and From fields.";
        const characterLimitErrorMsg = "<span style='font-family: \"BrandonGrotesque-Bold\"'>Oops!</span> Please fit message to character limit.";
        const notSavedErrorMsg = "<span style='font-family: \"BrandonGrotesque-Bold\"'>Oops!</span> Please save your gift message above.";

        // ----- Functions ------
        let Error = () => {
          function showGiftError(message = "") {
            giftingError.innerHTML = message;
            giftingError.classList.add("active");
          }

          function hideGiftError() {
            giftingError.classList.remove("active");
          }

          function showCartError(message = "") {
            cartError.innerHTML = message;
            cartError.classList.remove("sk-hidden");
          }

          function hideCartError() {
            cartError.classList.add("sk-hidden");
          }

          return Object.freeze({
            showGiftError,
            hideGiftError,
            showCartError,
            hideCartError,
          });
        }

        // Switching View
        // - toBody
        // - toView
        // - toNone
        let SwitchView = () => {
          let view = "";

          // Refresh view to current view
          function refresh() {
            toNone();

            if (view === "body") {
              giftingBody.classList.add("active");
            } else if (view === "view") {
              giftingView.classList.add("active");
            } else {
              // Default to show body
              view = "body";
              giftingBody.classList.add("active");
            }
          }

          // Show body
          function toBody() {
            view = "body";
            refresh();
          }

          // Show view
          function toView() {
            view = "view";
            refresh();
          }

          // Hide
          function toNone() {
            // Hide all gifting components
            giftingBody.classList.remove("active");
            giftingView.classList.remove("active");
            giftingError.classList.remove("active");
          }

          return Object.freeze({
            toBody,
            toView,
            toNone,
          });
        }

        let Body = () => {
          // Save
          function saveToView() {
            viewTo.innerText = `To: ${bodyTo.value}`;
            viewMessage.innerText = `"${bodyMessage.value}"`;
            viewFrom.innerText = `From: ${bodyFrom.value}`;

            if (bodyMessage.value.length > 0) {
              viewMessage.classList.add("active");
            } else {
              viewMessage.classList.remove("active");
            }
          }

          async function saveToLocal() {
            window.localStorage.setItem("giftMessageContent", bodyMessage.value);
            window.localStorage.setItem("giftMessageTo", bodyTo.value);
            window.localStorage.setItem("giftMessageFrom", bodyFrom.value);

            if (window.localStorage.getItem("giftMessageContent") !== null &&
                window.localStorage.getItem("giftMessageContent").length !== 0) {
              let result = await GiftCardMessagePropertyUpdater.update();
            } else {
              let result = await GiftCardMessagePropertyUpdater.clear();
            }
          }

          function saveToCartNote() {
            const giftMessage = `${giftMessageIdentifier} / To: ${bodyTo.value} / From: ${bodyFrom.value} / Message: ${bodyMessage.value}`;
            noteInput.value = giftMessage;
          }

          // Clear
          function clear() {
            bodyTo.value = "";
            bodyFrom.value = "";
            bodyMessage.value = "";
          }

          // Character count update
          function updateCharacterCount() {
            const count = bodyMessage.value.length;

            bodyCharacters.innerText = `${count} / ${characterLimit}`;
            viewCharacters.innerText = `${count} / ${characterLimit}`;

            if (count > characterLimit) {
              bodyCharacters.classList.add("error");
              viewCharacters.classList.add("error");
            } else {
              bodyCharacters.classList.remove("error");
              viewCharacters.classList.remove("error");
            }
          }

          // Save Message Click Handler
          function saveMessageClickHandler(e) {
            if (e) {
              e.preventDefault();
            }

            Error.hideGiftError();
            Error.hideCartError();

            // Check if both from and to exists
            if (bodyTo.value === "" || bodyTo.value.length <= 0 ||
                bodyFrom.value === "" || bodyFrom.value.length <= 0) {
              Error.showGiftError(fromToErrorMsg);

              return;
            }

            // Check if character limit isn't exceeded
            if (bodyMessage.value.length > characterLimit) {
              Error.showGiftError(characterLimitErrorMsg);

              return;
            }

            // Save contents of gift message to note input
            Body.saveToView();
            Body.saveToCartNote();
            Body.saveToLocal();

            SwitchView.toView();
          }

          // Init
          saveMessageBtn.addEventListener("click", saveMessageClickHandler);
          bodyMessage.addEventListener("input", updateCharacterCount);

          return Object.freeze({
            clear,
            saveToCartNote,
            saveToLocal,
            saveToView,
            updateCharacterCount,
          });
        }

        let View = () => {
          function clear() {
            viewFrom.innerText = "";
            viewTo.innerText = "";
            viewMessage.innerText = "";
          }

          function editMessageClickHandler(e) {
            if (e) {
              e.preventDefault();
            }

            SwitchView.toBody();
          }

          editMessageBtn.addEventListener("click", editMessageClickHandler);

          return Object.freeze({
            clear,
            editMessageClickHandler,
          });
        }

        let CartNote = () => {
          function clear() {
            noteInput.value = "";
          }

          return Object.freeze({
            clear,
          });
        }

        let Local = () => {
          async function loadToBody() {
            if (!exists()) {
              return;
            }

            bodyMessage.value = window.localStorage.getItem("giftMessageContent");
            bodyTo.value = window.localStorage.getItem("giftMessageTo");
            bodyFrom.value = window.localStorage.getItem("giftMessageFrom");

            Body.updateCharacterCount();

            if (window.localStorage.getItem("giftMessageContent") !== null &&
                window.localStorage.getItem("giftMessageContent").length !== 0) {
              let result = await GiftCardMessagePropertyUpdater.update();
            } else {
              let result = await GiftCardMessagePropertyUpdater.clear();
            }
          }

          function exists() {
            let content = window.localStorage.getItem("giftMessageContent");
            let to = window.localStorage.getItem("giftMessageTo");
            let from = window.localStorage.getItem("giftMessageFrom");

            return (content !== null && to !== null && from !== null && content.trim() !== "");
          }

          async function clear() {
            if (!exists()) {
              return;
            }

            window.localStorage.setItem("giftMessageContent", "");
            window.localStorage.setItem("giftMessageTo", "");
            window.localStorage.setItem("giftMessageFrom", "");

            let result = await GiftCardMessagePropertyUpdater.clear();
          }

          return Object.freeze({
            loadToBody,
            clear,
            exists,
          });
        }

        let Gifting = () => {
          // Enable/Disable
          function enable() {
            SwitchView.toBody();

            // Save to local
            Body.saveToLocal();

            // Save to view
            Body.saveToView();

            // Save to cart
            Body.saveToCartNote();
          }

          function disable() {
            SwitchView.toNone();

            // Clear local
            Local.clear();

            // Clear cart
            CartNote.clear();
          }

          // State
          function isActive() {
            return checkbox.checked && giftingBody.classList.contains("active");
          }

          // Handlers
          function checkboxCheck() {
            if (checkbox.checked) {
              Gifting.enable();
            } else {
              Gifting.disable();
            }
          }

          function cartCheckoutBtnClickHandler(e) {
            Global.Overlay.Background.startLoading();
            Error.hideGiftError();
            Error.hideCartError();

            if (Gifting.isActive()) {
              e.preventDefault();

              console.warn("Gift message and not saved");
              Error.showCartError(notSavedErrorMsg);

              Global.Overlay.Background.endLoading();

              return;
            }

            if (checkoutBtn.value === "Order Not Valid") {
              Global.Overlay.Background.endLoading();

              return;
            }
          }

          // Init
          checkbox.addEventListener("change", checkboxCheck);
          checkoutBtn.addEventListener("click", cartCheckoutBtnClickHandler);

          Array.from(document.querySelectorAll(".cart > form")).forEach(form => {
            form.addEventListener("submit", cartCheckoutBtnClickHandler);
          });

          return Object.freeze({
            enable,
            disable,
            isActive,
            checkboxCheck,
          });
        }

        // Init
        Error = Error();
        SwitchView = SwitchView();
        Body = Body();
        View = View();
        CartNote = CartNote();
        Local = Local();
        Gifting = Gifting();

        if (Local.exists()) {
          checkbox.checked = true;

          // Load from local
          Local.loadToBody();

          // Load from body
          Body.saveToView();
          Body.saveToCartNote();

          SwitchView.toView();
        }
      });
    }
  }

  return Object.freeze({
    init,
  });
})();

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    // TODO
    // giftMessageEnabled = document.querySelector(".cart-footer").getAttribute("data-gift-message-enabled");
    // GiftMessageObj.init();
  });
} else {
  // TODO
  // giftMessageEnabled = document.querySelector(".cart-footer").getAttribute("data-gift-message-enabled");
  // GiftMessageObj.init();
}

/**
 * Cart Checkpoints
 * - Checks cart at certain checkpoints with callbacks
 * - Current checkpoints:
 *   - On page load
 *   - On cart update
 *   - On checkout
 */
let CartCheckpoints = () => {
  const DEBUG = false;

  /* Sub callbacks */
  // - Oversized Shipping
  // - Checks and updates cart to be in accordance with the oversized shipping rule
  // - Cart can be provided ahead of time to prevent slowdown of requesting it
  async function oversizedShippingCheck(preCart = undefined) {
    // Oversized Shipping Rule
    // - Oversized products must have a corresponding oversized shipping fee
    // - General rule: # of oversized products === # of oversized shipping fee

    // get cart
    let cart = undefined;

    if (preCart) {
      cart = preCart;
    } else {
      cart = await fetch("/cart.js")
      .then(res => res.json())
      .then(res => res);
    }

    // empty check
    if (cart.item_count === 0) {
      return;
    }

    // get cart items
    let cartItems = cart.items;

    // get oversized product count
    // const OversizedTag = "OVERSIZED_SHIPPING";
    const OversizedShippingItemsThree = [
      41906051874978,
      41906070487202,
      41906072060066,
      41906074615970,
      41906076254370,
      41906077761698,
      41906080088226,
      40024251760802,
      41336489705634,
      41336495571106,
      41336493244578,
      41336491737250,
      40024228921506,
      41392408723618,
      41392412459170,
      41392431759522,
      41392414785698,
      41392400990370,
      41392389685410,
      41392386867362,
      41392377364642,
      41392375398562,
      41392361701538,
      41392344105122,
      41077220016290,
      40990220812450
    ];

    const OversizedShippingItemsFive = [
      41910592372898,
      41910592897186,
      41910593454242,
      41910593978530,
      41910597877922,
      41910598631586,
      41910599844002,
      41912790712482,
      41912791629986,
      41912793006242,
      41912794939554,
      41912797593762,
      41912799690914,
      41912800608418,
      40987590459554
    ];

    const OversizedThreeProducts = cartItems.filter(item => OversizedShippingItemsThree.find(subItem => subItem === item.variant_id));
    const OversizedFiveProducts = cartItems.filter(item => OversizedShippingItemsFive.find(subItem => subItem === item.variant_id));
    let oversizedThreeProductCount = 0;
    let oversizedFiveProductCount = 0;

    OversizedThreeProducts.forEach(item => {
      oversizedThreeProductCount += item.quantity;
    });

    OversizedFiveProducts.forEach(item => {
      oversizedFiveProductCount += item.quantity;
    });

    // Update cart based on product count
    const OversizedThreeFeeId = 42260920139938;
    const OversizedFiveFeeId = 42203539144866;

    if (oversizedThreeProductCount > 0 || oversizedFiveProductCount > 0) {
      // add oversized shipping fee product === oversized product count
      let res = await fetch("/cart/update.js", {
        body: JSON.stringify({
          updates: {
            [OversizedThreeFeeId]: oversizedThreeProductCount,
            [OversizedFiveFeeId]: oversizedFiveProductCount,
          }
        }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      })
      .then(res => {
        return res.json();
      })
      .then(res => {
        if (DEBUG) {
          console.log(res);
        }

        Global.SideCart.refresh();

        return res;
      });
    } else {
      // Remove all from cart
      let res = await fetch("/cart/update.js", {
        body: JSON.stringify({
          updates: {
            [OversizedThreeFeeId]: 0,
            [OversizedFiveFeeId]: 0,
          }
        }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      })
      .then(res => {
        return res.json();
      })
      .then(res => {
        if (DEBUG) {
          console.log(res);
        }

        Global.SideCart.refresh();

        return res;
      });
    }
  }

  /* Main callback */
  function check() {
    // oversizedShippingCheck();
  }

  /* Synchronous Main callback */
  async function syncCheck() {
    let res = await oversizedShippingCheck();
  }

  // Event Listeners
  const cartForms = document.querySelectorAll(".cart form");

  // if (cartForms) {
  //   cartForms.forEach(form => {
  //     form.addEventListener("submit", syncCheck);
  //   });
  // }

  check();

  // Return final object
  return Object.freeze({
    check,
    syncCheck,
  });
};

// Ready state check for cart checkpoints
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    CartCheckpoints = CartCheckpoints();
  });
} else {
  CartCheckpoints = CartCheckpoints();
}

/**
 * US Website check
 */
async function onLoad() {
  if (location.href.includes("#us") || location.href.includes("#US") || location.href.includes("#Us") || location.href.includes("#uS")) {
    history.replaceState(null, "", location.href.replace("#us", ""));
    history.replaceState(null, "", location.href.replace("#US", ""));
    history.replaceState(null, "", location.href.replace("#Us", ""));
    history.replaceState(null, "", location.href.replace("#uS", ""));

    if (document.body.getAttribute("data-cart-currency") !== "USD") {
      let result = await Global.Currency.changeAndRefresh({type: "us"});
    }
  }

  // Newsletter open on page load
  if (location.href.includes("newsletter_open=true")) {
    history.replaceState(null, "", location.href.replace("newsletter_open=true", ""))

    let openNewsletterInterval = setInterval(() => {
      try {
        GlobalNewsletterSignupModal.goToSignup();
        GlobalNewsletterSignupModal.show();
        clearInterval(openNewsletterInterval);
      } catch (e) {
        console.warn("Newsletter modal not found", e);
      }
    }, 1000);
  }

  // Open cart currency if session storage found
  let cartPage = sessionStorage.getItem("cart-menu__page");

  if (cartPage && cartPage === "currency") {
    document.querySelector(".cart.cart--side-cart.cart--new").classList.add("no-transition");

    setTimeout(() => {
      // Global.SideCart.show();
      // Global.SideCart.showLocationDropdown();
      RegionSelect.forceShow();

      sessionStorage.setItem("cart-menu__page", "")

      setTimeout(() => {
        document.querySelector(".cart.cart--side-cart.cart--new").classList.remove("no-transition");
      }, 510);
    }, 100);
  }
}

if(document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onLoad);
} else {
  onLoad();
}

/**
 * Notification Pop-up:
 * - Handles notification pop-ups
 */
let NotificationPopups = () => {
  const DEBUG = false;

  // Times
  let notificationAutoHideDelay = 5000;
  const notificationActivationDelay = 50;
  const notificationHideDelay = 450;
  const updateTopOffsetDelay = 100;
  const fastShowDelay = 150;
  const initTopOffsetDelay = 1000;
  const progressBarResetDelay = 100;

  // Timeouts
  let hideTimeout = undefined;
  let showTimeout = undefined;
  let autoTimeout = undefined;

  // Elements
  const notificationWindow = document.querySelector("#notification-window");
  const comparePriceElem = notificationWindow.querySelector(".body__add-to-cart .price > .compare-price");
  const imageElem = notificationWindow.querySelector(".body__add-to-cart .featured-img");
  const imageLinkElem = notificationWindow.querySelector(".body__add-to-cart > a");
  const priceElem = notificationWindow.querySelector(".body__add-to-cart .price > .price");
  const quantityElem = notificationWindow.querySelector(".body__add-to-cart .quantity-value");
  const variantTitleElem = notificationWindow.querySelector(".body__add-to-cart .variant-name");

  const closeBtn = notificationWindow.querySelector(".close-btn");
  const quantityMinus = notificationWindow.querySelector(".body__add-to-cart .quantity-minus");
  const quantityPlus = notificationWindow.querySelector(".body__add-to-cart .quantity-plus");

  const announcementBar = document.querySelector(".announcement-bar__root");
  const header = document.querySelector("#header-root");
  const headerFixedClass = "header-root--fixed";

  const progressBar = notificationWindow.querySelector(".progress-bar");
  const loadingIndicator = notificationWindow.querySelector(".loading-indicator");

  // Init
  const init = () => {
    // Elems
    notificationWindow.remove();
    document.body.appendChild(notificationWindow);

    closeBtn.addEventListener("click", hide);
    quantityElem.addEventListener("input", quantityChange);
    quantityMinus.addEventListener("click", quantityDecrease);
    quantityPlus.addEventListener("click", quantityIncrease);

    // Durations
    notificationAutoHideDelay = parseInt(notificationWindow.getAttribute("data-timeout"));

    setTimeout(updateTopOffset, initTopOffsetDelay);
  }

  // Quantity
  /**
   * Quantity Increase:
   * - Increases quantity by 1
   * @returns true if success, false if fail
   */
  const quantityIncrease = (e = undefined) => {
    if (e) {
      e.preventDefault();
    }

    const quantityInCart = parseInt(notificationWindow.getAttribute("data-quantity-cart"));
    const quantityMax = parseInt(notificationWindow.getAttribute("data-quantity-max"));
    const originalQuantity = parseInt(notificationWindow.getAttribute("data-quantity-original"));
    const max = quantityMax - quantityInCart + originalQuantity;
    const currQuantity = parseInt(notificationWindow.getAttribute("data-quantity-current"));
    let newQuantity = currQuantity + 1;

    if (Number.isNaN(newQuantity)) {
      newQuantity = 0;
    }

    // Reset progress and hide timer
    progressBarReset();
    clearTimeouts();
    autoTimeout = setTimeout(hide, notificationAutoHideDelay);

    if (newQuantity > max && quantityMax > 0) {
      quantityElem.value = currQuantity;
      return false;
    }

    quantityElem.value = newQuantity;
    notificationWindow.setAttribute("data-quantity-current", newQuantity);

    priceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${(parseFloat(notificationWindow.getAttribute("data-price")) * newQuantity).toFixed(2)}`;
    comparePriceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${(parseFloat(notificationWindow.getAttribute("data-compare-price")) * newQuantity).toFixed(2)}`;

    return true;
  }

  /**
   * Quantity Decrease:
   * - Decreases quantity by 1
   * @returns true if success, false if fail
   */
  const quantityDecrease = (e = undefined) => {
    if (e) {
      e.preventDefault();
    }

    const min = parseInt(notificationWindow.getAttribute("data-quantity-min"));
    const currQuantity = parseInt(notificationWindow.getAttribute("data-quantity-current"));
    let newQuantity = currQuantity - 1;

    if (Number.isNaN(newQuantity)) {
      newQuantity = 0;
    }

    // Reset progress and hide timer
    progressBarReset();
    clearTimeouts();
    autoTimeout = setTimeout(hide, notificationAutoHideDelay);

    if (newQuantity < min) {
      quantityElem.value = currQuantity;
      return false;
    }

    quantityElem.value = newQuantity;
    notificationWindow.setAttribute("data-quantity-current", newQuantity);

    priceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${(parseFloat(notificationWindow.getAttribute("data-price")) * newQuantity).toFixed(2)}`;
    comparePriceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${(parseFloat(notificationWindow.getAttribute("data-compare-price")) * newQuantity).toFixed(2)}`;

    return true;
  }

  /**
   * Quantity Change:
   * - Changes quantity based on quantity input
   * @returns true if success, false if fail
   */
  const quantityChange = (e = undefined) => {
    let target = e.currentTarget;

    // Update quantity
    const quantityInCart = parseInt(notificationWindow.getAttribute("data-quantity-cart"));
    const quantityMax = parseInt(notificationWindow.getAttribute("data-quantity-max"));
    const originalQuantity = parseInt(notificationWindow.getAttribute("data-quantity-original"));
    const min = parseInt(notificationWindow.getAttribute("data-quantity-min"));
    const max = quantityMax - quantityInCart + originalQuantity;
    const currQuantity = parseInt(notificationWindow.getAttribute("data-quantity-current"));
    let newQuantity = parseInt(target.value);

    if (Number.isNaN(newQuantity)) {
      newQuantity = 0;
    }

    // Reset progress and hide timer
    progressBarReset();
    clearTimeouts();
    autoTimeout = setTimeout(hide, notificationAutoHideDelay);

    if ((newQuantity > max && quantityMax > 0) || newQuantity < min) {
      target.value = currQuantity;
      return false;
    }

    target.value = newQuantity;
    notificationWindow.setAttribute("data-quantity-current", newQuantity);

    priceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${(parseFloat(notificationWindow.getAttribute("data-price")) * newQuantity).toFixed(2)}`;
    comparePriceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${(parseFloat(notificationWindow.getAttribute("data-compare-price")) * newQuantity).toFixed(2)}`;

    return true;
  }

  // Cart Update
  /**
   * Update Cart:
   * - Updates cart based on quantity in notification popup quantity input
   * @returns true if success, false if fail
   */
  const updateCart = () => {
    const originalQuantity = parseInt(notificationWindow.getAttribute("data-quantity-original"));
    const currentQuantity = parseInt(notificationWindow.getAttribute("data-quantity-current"));
    const quantityInCart = parseInt(notificationWindow.getAttribute("data-quantity-cart"));

    if (originalQuantity === currentQuantity) {
      return;
    }

    const quantityBeforeChange = quantityInCart - originalQuantity;
    const newQuantity = quantityBeforeChange + currentQuantity;

    Global.Cart.change({id: parseInt(notificationWindow.getAttribute("data-v-id")), quantity: newQuantity})
    .then(res => {
      Global.SideCart.refresh();
    })
    .catch(res => {
      if (DEBUG) {
        console.warn(res);
      }
    });
  }

  /**
   * Update Product Data:
   * - Updates product data to use
   * - Includes quantity max, quantity original, quantity current, vid
   */
  const updateProductData = ({quantityMax = 1, quantity = 1, variantId = 0, quantityCart = 0, price = "$10.00", comparePrice = "$0.00"} = {}) => {
    notificationWindow.setAttribute("data-quantity-max", quantityMax);
    notificationWindow.setAttribute("data-quantity-original", quantity);
    notificationWindow.setAttribute("data-quantity-current", quantity);
    notificationWindow.setAttribute("data-v-id", variantId);
    notificationWindow.setAttribute("data-quantity-cart", quantityCart);
    notificationWindow.setAttribute("data-price", (parseFloat(price.replace(document.body.getAttribute("data-currency-symbol"), "")) / quantity).toFixed(2));

    if (comparePrice !== undefined && comparePrice !== "" && parseFloat(comparePrice.replace(document.body.getAttribute("data-currency-symbol"), "")) > 0) {
      notificationWindow.setAttribute("data-compare-price", (parseFloat(comparePrice.replace(document.body.getAttribute("data-currency-symbol"), "")) / quantity).toFixed(2));
    } else {
      notificationWindow.setAttribute("data-compare-price", 0);
    }
  }

  // Scroll / Resize
  /**
   * Update Top Offset:
   * - Ensures notification window is tucked right under header
   */
  const updateTopOffset = () => {
    setTimeout(() => {
      // let announcementBarHeight = announcementBar.scrollHeight;
      let headerHeight = header.clientHeight;
      // let isHeaderFixed = header.classList.contains(headerFixedClass);

      let topOffset = headerHeight;

      // if (!isHeaderFixed) {
      //   if (window.scrollY <= announcementBarHeight) {
      //     topOffset += announcementBarHeight;
      //   }

      //   topOffset -= window.scrollY;
      // }

      notificationWindow.style = `top: ${topOffset}px !important;`;
    }, updateTopOffsetDelay);
  }

  // Timeout
  /**
   * Clear Timeouts:
   * - Clear all timeouts
   */
  const clearTimeouts = () => {
    // Clear show
    if (showTimeout) {
      clearTimeout(showTimeout);
    }

    // Clear auto
    if (autoTimeout) {
      clearTimeout(autoTimeout);
    }

    // Clear hide
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
  }

  // Progress Bar
  /**
   * Progress Bar Start:
   * - Starts progress bar animation
   */
  const progressBarStart = () => {
    progressBar.style.animation = "";
  }

  /**
   * Progress Bar End:
   * - Ends progress bar animation
   */
  const progressBarEnd = () => {
    progressBar.style.animation = "none";
  }

  /**
   * Progress Bar Reset:
   * - Resets progress bar animation
   */
  const progressBarReset = () => {
    setTimeout(() => {
      progressBar.style.animation = "none";

      setTimeout(() => {
        progressBar.style.animation = "";
      }, progressBarResetDelay);
    }, progressBarResetDelay);
  }

  // Visual
  /**
   * Force Hide:
   * - Hides without animation
   * @returns true if success, false if fail
   */
  const forceHide = () => {
    clearTimeouts();

    // Deactivate
    notificationWindow.classList.remove("active");
    notificationWindow.classList.add("sk-hidden");
    window.removeEventListener("scroll", updateTopOffset);
    window.removeEventListener("resize", updateTopOffset);

    progressBarEnd();
    updateCart();

    return true;
  }

  /**
   * Hide:
   * - Hides notification popup window
   * @returns true if success, false if fail
   */
  const hide = () => {
    // Deactivate
    notificationWindow.classList.remove("active");

    clearTimeouts();

    // Hide
    hideTimeout = setTimeout(() => {
      notificationWindow.classList.add("sk-hidden");
      window.removeEventListener("scroll", updateTopOffset);
      window.removeEventListener("resize", updateTopOffset);

      progressBarEnd();
      updateCart();
    }, notificationHideDelay);

    return true;
  }

  /**
   * Show Body:
   * - Shows notification popup window actual
   * @returns true if success, false if fail
   */
  const showBody = ({comparePrice = "$0.00", src = "https://cdn.shopify.com/s/files/1/0271/7351/9412/files/no-img.png?v=1659621679", price = "$10.00", link = "https://sukoshimart.com/", quantity = 1, variantTitle = "", quantityMax = 1, variantId = 0, quantityCart = 0} = {}) => {
    // Update body
    if (comparePrice !== undefined && comparePrice !== "" && parseFloat(comparePrice.replace(document.body.getAttribute("data-currency-symbol"), "")) > 0) {
      if (comparePrice.includes(document.body.getAttribute("data-currency-symbol"))) {
        comparePriceElem.innerText = comparePrice;
      } else {
        comparePriceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${comparePrice}`;
      }

      comparePriceElem.classList.add("active");
    } else {
      comparePriceElem.classList.remove("active");
    }

    imageElem.setAttribute("src", src);

    if (price.includes(document.body.getAttribute("data-currency-symbol"))) {
      priceElem.innerText = price;
    } else {
      priceElem.innerText = `${document.body.getAttribute("data-currency-symbol")}${price}`;
    }

    imageLinkElem.setAttribute("href", link);
    quantityElem.value = quantity;

    if (variantTitle !== undefined && variantTitle !== "" && variantTitle !== "Default Title") {
      variantTitleElem.innerText = variantTitle;
      variantTitleElem.classList.add("active");
    } else {
      variantTitleElem.classList.remove("active");
    }

    // Show
    notificationWindow.classList.remove("sk-hidden");

    updateTopOffset();
    clearTimeouts();

    // Activate
    startLoading();

    if (imageElem.complete) {
      stopLoading();
    } else {
      imageElem.addEventListener("load", stopLoading);
    }

    showTimeout = setTimeout(() => {
      notificationWindow.classList.add("active");
      window.addEventListener("scroll", updateTopOffset);
      window.addEventListener("resize", updateTopOffset);
      clearTimeouts();

      // Start countdown to hide notification
      showTimeout = setTimeout(() => {
        notificationWindow.classList.add("active");

        progressBarStart();
        clearTimeouts();

        // Auto hide
        autoTimeout = setTimeout(hide, notificationAutoHideDelay);
      }, notificationActivationDelay);
    }, notificationActivationDelay);

  }

  /**
   * Show:
   * - Shows notification popup window
   * @returns true if success, false if fail
   */
  const show = ({comparePrice = "$0.00", src = "https://cdn.shopify.com/s/files/1/0271/7351/9412/files/no-img.png?v=1659621679", price = "$10.00", link = "https://sukoshimart.com/", quantity = 1, variantTitle = "", quantityMax = 1, variantId = 0, quantityCart = 0} = {}) => {
    // Error check
    if (price === undefined || src === undefined || link === undefined || quantity === undefined || variantId === undefined || variantId === 0 || quantityMax === 0) {
      if (DEBUG) {
        console.warn("Invalid input for notification popup");
      }

      return false;
    }

    // Hide if already active
    if (notificationWindow.classList.contains("active")) {
      forceHide();
      progressBarReset();

      showTimeout = setTimeout(() => {
        showBody({comparePrice, src, price, link, quantity, variantTitle, quantityMax, variantId, quantityCart});
      }, fastShowDelay);
    } else {
      showBody({comparePrice, src, price, link, quantity, variantTitle, quantityMax, variantId, quantityCart});
    }

    updateProductData({quantityMax, quantity, variantId, quantityCart, price, comparePrice});

    return true;
  }

  /**
   * Loading
   */
  function startLoading() {
    imageElem.classList.add("loading");
    loadingIndicator.classList.add("active");

    progressBarEnd();
    clearTimeouts();
  }

  function stopLoading() {
    // Show img
    imageElem.removeEventListener("load", stopLoading);
    loadingIndicator.classList.remove("active");
    imageElem.classList.remove("loading");

    // Start countdown to hide notification
    if (showTimeout) clearTimeout(showTimeout);
    showTimeout = setTimeout(() => {
      notificationWindow.classList.add("active");

      progressBarStart();
      clearTimeouts();

      // Auto hide
      autoTimeout = setTimeout(hide, notificationAutoHideDelay);
    }, notificationActivationDelay);
  }

  init();

  return Object.freeze({
    forceHide,
    hide,
    show,
  });
}

if(document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    NotificationPopups = NotificationPopups();
  });
} else {
  NotificationPopups = NotificationPopups();
}

/*
  Handles country selectors for rich text
*/
// const CustomCountrySelector = (() => {
//   // Changes region to found value if valid
//   function changeRegionHandler(e = undefined) {
//     if (e) {
//       e.preventDefault();
//     } else {
//       return;
//     }

//     // Get region value
//     let target = e.currentTarget;
//     let region = target.value.toLowerCase();

//     // Cancel if default
//     if (region === "default") return;

//     // Change region to value
//     Global.Currency.changeAndRefresh({type: region, target: target});
//   }

//   return Object.freeze({
//     changeRegionHandler,
//   });
// })();

// /*
//   =====
//   Geolocation API
//   =====
// */
// const CustomGeolocation = (() => {
//   /*
//     Should run on start
//   */
//   function Start() {
//     if (navigator.geolocation) {
//       // geolocation is supported
//       navigator.geolocation.getCurrentPosition(
//         GeolocationSuccess,
//         GeolocationError,
//         {
//           enableHighAccuracy : true,
//           timeout : 30000,
//           maximumAge : 10000
//         }
//       );
//     } else {
//       // geolocation is not supported
//       console.log('geolocation is not enabled on this browser');
//     }
//   }

//   /*
//     Show any province that is selected
//   */
//   function ShowProvince(province = null) {
//     if (!province) return;

//     let foundProvince = false;

//     // find all province items
//     Array.from(document.querySelectorAll(`.sk-province`)).forEach(provinceItem => {
//       let provinceFormatted = province.toLowerCase();
//       let dataFormatted = provinceItem.getAttribute("data-province").toLowerCase();

//       if (provinceFormatted === dataFormatted) {
//         // found match -- show and set found flag true
//         provinceItem.classList.remove("sk-hidden");
//         foundProvince = true;
//       } else {
//         // hide
//         provinceItem.parentElement.classList.add("sk-hidden");
//       }
//     });

//     // if any province found, hide main canada setting
//     if (foundProvince) {
//       Array.from(document.querySelectorAll(".sk-region-canada")).forEach(canadaItem => {
//         canadaItem.parentElement.classList.add("sk-hidden");
//       });
//     }
//   }

//   /*
//     Success handling for geolocation
//   */
//   function GeolocationSuccess(position) {
//     // Correct lat and lon
//     const lat = position.coords.latitude + 6;
//     const lon = position.coords.longitude - 3;

//     console.log('latitude', lat, 'longitude', lon);

//     // Skip if already found
//     if (localStorage.getItem("sk-province") != null) {
//       ShowProvince(localStorage.getItem("sk-province"));
//       return;
//     }

//     // location data - ROUGH APPROX. -- TO BE UPDATED WITH MORE ACCURACY
//     // Tried testing with vpn, doesn't seem to change lon or lat..
//     const ON_LAT1 = 41.013;
//     const ON_LAT2 = 57.017;
//     const ON_LON1 = -95.98;
//     const ON_LON2 = -76.15;

//     const QC_LAT1 = 40.280;
//     const QC_LAT2 = 62.714;
//     const QC_LON1 = -75.146;
//     const QC_LON2 = -68.599;

//     const BC_LAT1 = 47.606;
//     const BC_LAT2 = 60.021;
//     const BC_LON1 = -139.570;
//     const BC_LON2 = -119.619;

//     const AB_LAT1 = 48.922;
//     const AB_LAT2 = 60.087;
//     const AB_LON1 = -120.103;
//     const AB_LON2 = -109.819;

//     const SK_LAT1 = 48.922;
//     const SK_LAT2 = 60.021;
//     const SK_LON1 = -110.083;
//     const SK_LON2 = -101.250;

//     const MB_LAT1 = 48.807;
//     const MB_LAT2 = 60.131;
//     const MB_LON1 = -102.085;
//     const MB_LON2 = -88.857;

//     const NS_LAT1 = 42.940;
//     const NS_LAT2 = 45.951;
//     const NS_LON1 = -66.819;
//     const NS_LON2 = -58.832;

//     const PE_LAT1 = 45.928;
//     const PE_LAT2 = 47.636;
//     const PE_LON1 = -64.589;
//     const PE_LON2 = -61.490;

//     const NB_LAT1 = 44.190;
//     const NB_LAT2 = 48.122;
//     const NB_LON1 = -67.335;
//     const NB_LON2 = -65.149;

//     const NL_LAT1 = 47.309;
//     const NL_LAT2 = 60.392;
//     const NL_LON1 = -65.566;
//     const NL_LON2 = -51.724;

//     const YT_LAT1 = 59.845;
//     const YT_LAT2 = 70.036;
//     const YT_LON1 = -141.284;
//     const YT_LON2 = -123.442;

//     const NT_LAT1 = 59.87;
//     const NT_LAT2 = 79.43;
//     const NT_LON1 = -126.96;
//     const NT_LON2 = -101.95;

//     const NU_LAT1 = 60.06;
//     const NU_LAT2 = 83.42;
//     const NU_LON1 = -102.57;
//     const NU_LON2 = -59.24;

//     if (ON_LAT1 < lat && lat < ON_LAT2 && ON_LON1 < lon && lon < ON_LON2) {
//       // show on
//       localStorage.setItem("sk-province", "ON");
//     } else if (QC_LAT1 < lat && lat < QC_LAT2 && QC_LON1 < lon && lon < QC_LON2) {
//       // show qc
//       localStorage.setItem("sk-province", "QC");
//     } else if (BC_LAT1 < lat && lat < BC_LAT2 && BC_LON1 < lon && lon < BC_LON2) {
//       // show bc
//       localStorage.setItem("sk-province", "BC");
//     } else if (AB_LAT1 < lat && lat < AB_LAT2 && AB_LON1 < lon && lon < AB_LON2) {
//       // show ab
//       localStorage.setItem("sk-province", "AB");
//     } else if (SK_LAT1 < lat && lat < SK_LAT2 && SK_LON1 < lon && lon < SK_LON2) {
//       // show sk
//       localStorage.setItem("sk-province", "SK");
//     } else if (MB_LAT1 < lat && lat < MB_LAT2 && MB_LON1 < lon && lon < MB_LON2) {
//       // show manitoba
//       localStorage.setItem("sk-province", "MB");
//     } else if (NS_LAT1 < lat && lat < NS_LAT2 && NS_LON1 < lon && lon < NS_LON2) {
//       // show nova scotia
//       localStorage.setItem("sk-province", "NS");
//     } else if (PE_LAT1 < lat && lat < PE_LAT2 && PE_LON1 < lon && lon < PE_LON2) {
//       // show pei
//       localStorage.setItem("sk-province", "PE");
//     } else if (NB_LAT1 < lat && lat < NB_LAT2 && NB_LON1 < lon && lon < NB_LON2) {
//       // show nb
//       localStorage.setItem("sk-province", "NB");
//     } else if (NL_LAT1 < lat && lat < NL_LAT2 && NL_LON1 < lon && lon < NL_LON2) {
//       // show nfl
//       localStorage.setItem("sk-province", "NL");
//     } else if (YT_LAT1 < lat && lat < YT_LAT2 && YT_LON1 < lon && lon < YT_LON2) {
//       // show yukon
//       localStorage.setItem("sk-province", "YT");
//     } else if (NT_LAT1 < lat && lat < NT_LAT2 && NT_LON1 < lon && lon < NT_LON2) {
//       // show nwt
//       localStorage.setItem("sk-province", "NT");
//     } else if (NU_LAT1 < lat && lat < NU_LAT2 && NU_LON1 < lon && lon < NU_LON2) {
//       // show nunavut
//       localStorage.setItem("sk-province", "NU");
//     } else {
//       // show canada
//       if (localStorage.getItem("sk-province") != null) localStorage.clearItem("sk-province");
//     }

//     if (localStorage.getItem("sk-province") != null) console.log("PROVINCE:", localStorage.getItem("sk-province"));

//     ShowProvince(localStorage.getItem("sk-province"));
//   }

//   /*
//     Error handling for geolocation
//   */
//   function GeolocationError(error_message) {
//     console.error('An error has occured while retrieving location', error_message);
//   }

//   return Object.freeze({
//     Start,
//   });
// })();


// if(document.readyState === "loading") {
//   document.addEventListener("DOMContentLoaded", () => {
//     CustomGeolocation.Start();
//   });
// } else {
//   CustomGeolocation.Start();
// }

/* Get customer points */
function GetCustomerPoints() {
  let menuPoints = document.querySelector(".menu-bar .menu-points");
  let mobileMenuPoints = document.querySelector(".menu-bottom .menu-points");

  window.sdk = new MindsSDK.Loyalty({
    apiKey: 'key_live_WHKb_W8r9k0DCj9EDzklxNJpv1hE6IOAyNQwmQNMjHE',
    platform: 'SHOPIFY',
    shopDomain: 'sukoshi-mart-online.myshopify.com'
  });

  (async () => {
    try {
      const sdk = await window.sdk.onReady(); // Wait for SDK to be ready

      window.myinfo = await sdk.resource.getInfo();
      window.pointsBalance = await sdk.resource.getPointsBalance();

      if (window.pointsBalance.data === undefined) {
        menuPoints.innerText = 0 + " points";
        mobileMenuPoints.innerText = 0 + " points";

        return;
      }

      let pointVal = window.pointsBalance.data.point_balance;

      menuPoints.innerText = pointVal + " points";
      mobileMenuPoints.innerText = pointVal + " points";
    } catch (error) {
      console.error('Error fetching rewards:', error);
    }
  })();
}

/* Update customer point balance */
async function CustomerPoints() {
  let DEBUG = false;
  let menuPoints = document.querySelector(".menu-bar .menu-points");
  let mobileMenuPoints = document.querySelector(".menu-bottom .menu-points");

  if (menuPoints || mobileMenuPoints) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        GetCustomerPoints();
      });
    } else {
      GetCustomerPoints();
    }
  }

  return;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    setInterval(CustomerPoints(), 60000);
  });
} else {
  CustomerPoints();
}

const FooterLiveChat = () => {
  let searchCount = 0;

  function showChat(e = undefined) {
    e.preventDefault();
    document.getElementById("gorgias-chat-container").classList.remove("sk-hidden");

    document.querySelector(".overlay-chat-btn__container .overlay-chat-btn.overlay-chat-btn--small").classList.add("sk-hidden");
    document.querySelector(".overlay-chat-btn__container .overlay-chat-btn.overlay-chat-btn--large").classList.add("sk-hidden");
    document.querySelector(".overlay-chat-btn__container .overlay-close-chat-btn").classList.remove("sk-hidden");

    window.GorgiasChat.open();
  }

  function findChat() {
    if (window.GorgiasChat && window.GorgiasChat.isBusinessHours()) {
      document.querySelector(".global-footer .live-chat-btn").classList.add("found");
      document.querySelector(".global-footer .live-chat-btn .open").classList.remove("sk-hidden");
      document.querySelector(".global-footer .live-chat-btn .closed").classList.add("sk-hidden");
      document.getElementById("gorgias-chat-container").classList.remove("sk-hidden");

      document.querySelector(".global-footer .live-chat-btn").addEventListener("click", showChat);

      // Find Track an order -> If found, apply live chat button to it
      let trackOrderLinks = Array.from(document.querySelectorAll(".global-footer .footer-link ul li a")).filter(link => link.innerText === "Track an order");
      trackOrderLinks.forEach(link => {
        link.addEventListener("click", showChat);
      });
    } else if (window.GorgiasChat && !window.GorgiasChat.isBusinessHours()) {
      document.querySelector(".global-footer .live-chat-btn").classList.add("found");
      document.querySelector(".global-footer .live-chat-btn .open").classList.add("sk-hidden");
      document.querySelector(".global-footer .live-chat-btn .closed").classList.remove("sk-hidden");
      document.getElementById("gorgias-chat-container").classList.remove("sk-hidden");

      document.querySelector(".global-footer .live-chat-btn").addEventListener("click", showChat);

      // Find Track an order -> If found, apply live chat button to it
      let trackOrderLinks = Array.from(document.querySelectorAll(".global-footer .footer-link ul li a")).filter(link => link.innerText === "Track an order");
      trackOrderLinks.forEach(link => {
        link.addEventListener("click", showChat);
      });
    } else {
      if (searchCount < 20) {
        setTimeout(findChat, 2500);
        searchCount++;
      }
    }
  }

  findChat();
};

setTimeout(() => {
  FooterLiveChat();
}, 2500);
